<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div v-if="vmodel.configuration">
    <header class="header white-bg">
      <div style="text-decoration: none; color: black; cursor: pointer">
        <h2 class="m-0 mb-1 profile-text" @click="ShowChangesCheck = true">
          {{ vmodel.configuration.setName }}
          <!-- {{ staticData.general.optin }} -->
        </h2>
        <Breadcrumb :model="items" class="items-text" />
      </div>
      <Dialog
        header="Discard changes without saving"
        position="top "
        modal
        v-model:visible="ShowChangesCheck"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
        :style="{ width: '30vw' }"
      >
        <span>{{
          "Are you sure you want to go back without saving your changes?"
        }}</span>
        <template #footer>
          <PrimeButton
            label="Cancel"
            class="btn-cancel"
            @click="ShowChangesCheck = false"
          ></PrimeButton>
          <PrimeButton
            label="Yes,Sure"
            class="btn-sure"
            @click="stayOnPage(ShowChangesCheck, true)"
          ></PrimeButton>
        </template>
      </Dialog>
      <Dialog
        header
        position="top"
        v-model:visible="displayPublish"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
        :style="{ width: '30vw' }"
      >
        <div class="text-center">
          <h2 class="block">{{ lmodel.draftPublishTitle }}</h2>
          <h5 class="block">{{ lmodel.draftPulishText }}</h5>
          <div class="grid mt-2">
            <div class="col-6 mt-2">
              <PrimeButton
                icon="fa fa-rocket"
                :label="lmodel.draftPublishNowButton"
                id="btnPublishNow"
                class="save-btn1"
                @click="generateNowClick('publishnow')"
                :disabled="$store.state.loader == true"
              ></PrimeButton>
            </div>
            <div class="col-6 mt-2">
              <PrimeButton
                icon="fa fa-clock-o"
                :label="lmodel.draftPublishLaterButton"
                id="btnPublishLater"
                class="save-btn1"
                @click="[(displaySelectDate = true), (displayPublish = false)]"
              ></PrimeButton>
              <label
                v-if="vmodel.startDate != null && vmodel.startDate != undefined"
                >{{ lmodel.draftStartdate }} : {{ vmodel.startDate }}</label
              >
            </div>
            <div class="col-12 mt-2">
              <PrimeButton
                id="btnDoNotPublish"
                icon="fa fa-clock-o"
                :label="lmodel.draftNotPublishButton"
                class="save-btn1"
                @click="generateNot('save')"
                :disabled="$store.state.loader == true"
              ></PrimeButton>
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        header
        position="top"
        v-model:visible="displaySelectDate"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
        :style="{ width: '30vw' }"
      >
        <div>
          <div class="row">
            <div class="col-12">
              <label
                v-tooltip="lmodel.dealStartDateLabelToolTip"
                class="block"
                id="startdate-tooltip"
                >{{ lmodel.pubDealStartDate }}</label
              >
              <Calendar
                id="calendar-startdate"
                v-model="startDate"
                lang="en"
                :placeholder="lmodel.pubDealStartDatePlaceholder"
                showTime
                hourFormat="24"
                dateFormat="yy-mm-dd"
                showIcon
                :minDate="new Date()"
                class="w-full mt-1 calBorder"
              />
              <span
                v-if="v$.vmodel.publishStartDate.startDate.$invalid === true"
                class="p-error ml-1 mt-2"
                id="startdate-help"
                :style="
                  v$.vmodel.publishStartDate.startDate.$error
                    ? 'display:block;'
                    : 'display:none;'
                "
                >{{ staticData.createdeal.stdate_req }}</span
              >
              <span v-if="modelstate.pubStartDate" class="text-danger">
                {{ modelstate.pubStartDate }}
              </span>
            </div>
          </div>
        </div>

        <template #footer>
          <PrimeButton
            icon="fa fa-arrow-right"
            :label="staticData.createdeal.continue_publish"
            id="btnContinuePublishLater"
            class="save-btn1"
            @click="generateLater('publish')"
            :disabled="$store.state.loader == true"
          ></PrimeButton>
        </template>
      </Dialog>

      <div class="text-right" style="display: flex">
        <div
          style="display: flex"
          v-if="$route.name !== 'ManageDealUpdateCreate'"
        >
          <PrimeButton
            :icon="getStatusIconClass()"
            :class="getStatusButtonClass()"
          ></PrimeButton>
          <span class="live-text">{{ vmodel.statusText }}</span>
        </div>
        <div>
          <span class="verti-line"></span>
        </div>

        <div class="border-box-button">
          <PrimeButton
            icon="pi pi-mobile"
            :class="mobileSelect ? 'active-btn' : 'mobile'"
            @click="deviceType('mobile')"
          ></PrimeButton>
          <PrimeButton
            icon="pi pi-desktop"
            :class="desktopSelect ? 'active-btn' : 'desktop'"
            @click="deviceType('desktop')"
          ></PrimeButton>
        </div>
        <Dropdown
          v-if="$route.name !== 'ManageDealUpdateCreate'"
          v-model="selectedPreview"
          @change="previewWidget"
          :options="previewoptions"
          optionLabel="text"
          optionValue="value"
          :placeholder="previewoptions[0].text"
          class="widget-menudropdown ml-2"
        />
        <PrimeButton
          :label="lmodel.pubDealPauseButton"
          v-if="vmodel.status == 0"
          @click="statusChangePopup(id, `Pause`)"
          class="pause-btn ml-2 mr-2"
          icon="pause-icon"
        ></PrimeButton>
        <SplitButton
          v-if="$route.name !== 'ManageDealUpdateCreate'"
          :model="setItems"
          label
          class="pause-btn p-button-text p-button-secondary icon item"
        ></SplitButton>
        <PrimeButton
          label="Update"
          class="save-btn1 ml-2 mr-2"
          icon="save-icon"
          @click="(submitter = 'apply'), saveData()"
        ></PrimeButton>
      </div>
    </header>

    <div class="wizard-menu" v-if="vmodel.configuration && vmodel.referrals">
      <TabView class="wizard-tabview">
        <TabPanel>
          <template #header>
            <div
              @click="activateTab('setting')"
              class="tab-view"
              :class="{
                'error-state': hasValidationError('settings'),
              }"
            >
              <div class="icon-container">
                <i
                  :class="{
                    'settings-header-icon': !settingTab,
                    'settings-header-icon-changed': settingTab,
                  }"
                ></i>
              </div>
              <span
                :class="{
                  'wizard-text-color':
                    settingTab && !hasValidationError('settings'),
                  'wizard-text': !settingTab && !hasValidationError('settings'),
                  'error-state': hasValidationError('settings'),
                }"
              >
                {{ staticData.general.settings }}
                <div v-if="settingTab"></div>
              </span>
            </div>
          </template>
        </TabPanel>

        <TabPanel
          :disabled="true"
          v-if="vmodel.configuration?.ambNeverDisplay == false"
        >
          <template #header>
            <span class="vertical-line ml-2"></span>
          </template>
        </TabPanel>
        <TabPanel v-if="vmodel.configuration?.ambNeverDisplay == false">
          <template #header>
            <div
              @click="activateTab('minimized')"
              class="tab-view"
              :class="{
                'error-state': hasValidationError('minimized'),
              }"
            >
              <div class="icon-container">
                <img
                  src="../../assets/images/wizardImages/Minimized-img.png"
                  class="wizard-image"
                />
              </div>

              <span
                :class="{
                  'wizard-text-color':
                    minimizedTab && !hasValidationError('minimized'),
                  'wizard-text':
                    !minimizedTab && !hasValidationError('minimized'),
                  'error-state': hasValidationError('minimized'),
                }"
              >
                {{ staticData.general.minimized }}
                <div v-if="minimizedTab"></div>
              </span>
            </div>
          </template>
        </TabPanel>
        <TabPanel
          :disabled="true"
          v-if="vmodel.configuration?.ambNeverDisplay == false"
        >
          <template #header>
            <div class="arrow-container">
              <i style="font-size: 1rem" class="fa fa-solid fa-arrow-right"></i>
            </div>
          </template>
        </TabPanel>
        <TabPanel v-if="vmodel.configuration?.ambNeverDisplay == false">
          <template #header>
            <div
              @click="activateTab('maximized')"
              class="tab-view"
              :class="{
                'error-state': hasValidationError('maximized'),
              }"
            >
              <div class="icon-container">
                <img
                  src="../../assets/images/wizardImages/Maximized-img.png"
                  class="wizard-image"
                />
              </div>
              <span
                :class="{
                  'wizard-text-color':
                    maximizedTab && !hasValidationError('maximized'),
                  'wizard-text':
                    !maximizedTab && !hasValidationError('maximized'),
                  'error-state': hasValidationError('maximized'),
                }"
              >
                {{ staticData.general.maximized }}
                <div v-if="maximizedTab"></div>
              </span>
            </div>
          </template>
        </TabPanel>
        <TabPanel
          :disabled="true"
          v-if="vmodel.configuration?.ambNeverDisplay == false"
        >
          <template #header>
            <div class="arrow-container">
              <i style="font-size: 1rem" class="fa fa-solid fa-arrow-right"></i>
            </div>
          </template>
        </TabPanel>
        <TabPanel v-if="vmodel.configuration?.ambNeverDisplay == false">
          <template #header>
            <div
              @click="activateTab('message')"
              class="tab-view"
              :class="{
                'error-state': hasValidationError('message'),
              }"
            >
              <div class="icon-container">
                <img
                  src="../../assets/images/wizardImages/Messages-img.png"
                  class="wizard-image"
                />
              </div>
              <span
                :class="{
                  'wizard-text-color':
                    messageTab && !hasValidationError('message'),
                  'wizard-text': !messageTab && !hasValidationError('message'),
                  'error-state': hasValidationError('message'),
                }"
              >
                {{ staticData.general.message }}
                <div v-if="messageTab"></div>
              </span>
            </div>
          </template>
        </TabPanel>
        <TabPanel
          :disabled="true"
          v-if="vmodel.configuration?.ambNeverDisplay == false"
        >
          <template #header>
            <div class="arrow-container">
              <i style="font-size: 1rem" class="fa fa-solid fa-arrow-right"></i>
            </div>
          </template>
        </TabPanel>
        <TabPanel v-if="vmodel.configuration?.ambNeverDisplay == false">
          <template #header>
            <div @click="activateTab('returnvisit')" class="tab-view">
              <div class="icon-container">
                <img
                  src="../../assets/images/wizardImages/Return-visit-img.png"
                  class="wizard-image"
                />
              </div>
              <span
                :class="{
                  'wizard-text-color': returnTab,
                  'wizard-text': !returnTab,
                }"
              >
                {{ staticData.general.returnvisit }}
                <div v-if="returnTab"></div>
              </span>
            </div>
          </template>
        </TabPanel>
        <TabPanel
          :disabled="true"
          v-if="
            vmodel.configuration?.ambNeverDisplay == false &&
            vmodel.referrals?.ambDisablereferrals == false
          "
        >
          <template #header>
            <div class="vertical-line-disable"></div>
          </template>
        </TabPanel>
        <TabPanel
          v-if="
            vmodel.configuration?.ambNeverDisplay == false &&
            vmodel.referrals?.ambDisablereferrals == false
          "
        >
          <template #header>
            <div @click="activateTab('friendminimized')" class="tab-view">
              <div class="icon-container">
                <img
                  src="../../assets/images/wizardImages/Minimized-img.png"
                  class="wizard-image"
                />
              </div>
              <span
                :class="{
                  'wizard-text-color': friendminimizedTab,
                  'wizard-text': !friendminimizedTab,
                }"
              >
                {{ staticData.general.frndminimized }}
                <div v-if="friendminimizedTab"></div>
              </span>
            </div>
          </template>
        </TabPanel>
        <TabPanel
          :disabled="true"
          v-if="
            vmodel.configuration?.ambNeverDisplay == false &&
            vmodel.referrals?.ambDisablereferrals == false
          "
        >
          <template #header>
            <div class="arrow-container">
              <i style="font-size: 1rem" class="fa fa-solid fa-arrow-right"></i>
            </div>
          </template>
        </TabPanel>
        <TabPanel
          v-if="
            vmodel.configuration?.ambNeverDisplay == false &&
            vmodel.referrals?.ambDisablereferrals == false
          "
        >
          <template #header>
            <div
              @click="activateTab('frdmaximized')"
              class="tab-view"
              :class="{
                'error-state': hasValidationError('frdMaximized'),
              }"
            >
              <div class="icon-container">
                <img
                  src="../../assets/images/wizardImages/Maximized-img.png"
                  class="wizard-image"
                />
              </div>
              <span
                :class="{
                  'wizard-text-color':
                    frdmaximizedTab && !hasValidationError('frdMaximized'),
                  'wizard-text':
                    !frdmaximizedTab && !hasValidationError('frdMaximized'),
                  'error-state': hasValidationError('frdMaximized'),
                }"
              >
                {{ staticData.general.frndmaximized }}
                <div v-if="frdmaximizedTab"></div>
              </span>
            </div>
          </template>
        </TabPanel>
        <TabPanel
          :disabled="true"
          v-if="
            vmodel.configuration?.ambNeverDisplay == false &&
            vmodel.referrals?.ambDisablereferrals == false
          "
        >
          <template #header>
            <div class="arrow-container">
              <i style="font-size: 1rem" class="fa fa-solid fa-arrow-right"></i>
            </div>
          </template>
        </TabPanel>
        <TabPanel
          v-if="
            vmodel.configuration?.ambNeverDisplay == false &&
            vmodel.referrals?.ambDisablereferrals == false
          "
        >
          <template #header>
            <div @click="activateTab('friendmessage')" class="tab-view">
              <div class="icon-container">
                <img
                  src="../../assets/images/wizardImages/Messages-img.png"
                  class="wizard-image"
                />
              </div>
              <span
                :class="{
                  'wizard-text-color': friendmessageTab,
                  'wizard-text': !friendmessageTab,
                }"
              >
                {{ staticData.general.frndmessage }}
                <div v-if="friendmessageTab"></div>
              </span>
            </div>
          </template>
        </TabPanel>
        <TabPanel
          :disabled="true"
          v-if="
            vmodel.configuration?.ambNeverDisplay == false &&
            vmodel.referrals?.ambDisablereferrals == false
          "
        >
          <template #header>
            <div class="arrow-container">
              <i style="font-size: 1rem" class="fa fa-solid fa-arrow-right"></i>
            </div>
          </template>
        </TabPanel>
        <TabPanel
          v-if="
            vmodel.configuration?.ambNeverDisplay == false &&
            vmodel.referrals?.ambDisablereferrals == false
          "
        >
          <template #header>
            <div @click="activateTab('friendreturnvisit')" class="tab-view">
              <div class="icon-container">
                <img
                  src="../../assets/images/wizardImages/Return-visit-img.png"
                  class="wizard-image"
                />
              </div>
              <span
                :class="{
                  'wizard-text-color': friendreturnvisitTab,
                  'wizard-text': !friendreturnvisitTab,
                }"
                >{{ staticData.general.frndreturnvisit }}</span
              >
            </div>
          </template>
        </TabPanel>
      </TabView>
    </div>

    <!-- For Sidebar -->
    <aside></aside>

    <!-- <FindAndReplace :ShowPopup="showPopup" userType @closepopup="closePopup" /> -->

    <!-- FindandReplace Dialog box -->
    <Dialog
      modal
      v-model:visible="ShowFindPopup"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ maxwidth: '33vw' }"
      class="sendMailDialog"
    >
      <div class="header-container">
        <span class="text-header">{{ staticData.replace.find_replace }}</span>
        <i @click="handleClose" class="pi pi-times cursor-pointer"></i>
      </div>
      <div class="dialog-content1">
        <div class="input-container1">
          <label for="findtext-tooltip" class="control-label">
            {{ staticData.replace.find }}
          </label>
          <InputText v-model="inputTextValue" placeholder="Search"></InputText>
          <PrimeButton
            label="Search"
            class="search-btn ml-2"
            icon="find-icon"
            @click="handleSearch"
            :disabled="
              inputTextValue == null ||
              inputTextValue == undefined ||
              inputTextValue == ''
            "
          ></PrimeButton>
        </div>
      </div>
      <div class>
        <div class="input-container2">
          <label for="replacetext-tooltip" class="control-label">
            {{ staticData.replace.replace_with }}
          </label>
          <InputText
            v-model="replaceTextValue"
            placeholder="Replace with"
            :disabled="isReplaceButtonDisabled"
            class="mt-2"
          ></InputText>
        </div>
      </div>

      <div style="overflow-y: scroll">
        <span>{{ searchCount }}</span>
        <div style="max-width: 400px">{{ replaceTextLbl }}</div>
      </div>
      <template #footer>
        <div class="footer-container">
          <PrimeButton
            label="Replace"
            class="save-btn1"
            icon="replace-icon"
            @click="FindReplace"
            :disabled="
              replaceTextValue == null ||
              replaceTextValue == undefined ||
              replaceTextValue == ''
            "
          ></PrimeButton>
          <PrimeButton
            label="Cancel"
            class="remove-btn"
            icon="pi pi-times"
            @click="cancel"
          ></PrimeButton>
        </div>
      </template>
    </Dialog>

    <Dialog
      header="Warning"
      position="top "
      v-model:visible="displayReplace"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '33vw' }"
    >
      <span>{{ "Are you sure to replace?" }}</span>
      <template #footer>
        <PrimeButton
          label="Cancel"
          class="btn-cancel"
          @click="onReplaceCancel"
        ></PrimeButton>
        <PrimeButton
          label="Yes"
          class="save-btn1"
          @click="handleReplace()"
        ></PrimeButton>
      </template>
    </Dialog>

    <!-- Settings page -->
    <div v-if="settingTab">
      <div>
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid" style="margin-top: 180px">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>

                  <div
                    :class="
                      !isDisabled && isCancelClick
                        ? 'header-edit-mode'
                        : 'head-mode'
                    "
                  >
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    >
                      <div class="grid header-text">
                        <div class="col-12 xl:col-1">
                          <i class="settings-icon"></i>
                        </div>
                        <div
                          class="col-12 xl:col-10"
                          :class="{
                            'error-state-set ':
                              hasValidationError('configuration'),
                          }"
                        >
                          <span
                            class="heading-text"
                            :class="{
                              'error-state-set ':
                                hasValidationError('configuration'),
                            }"
                            >{{ staticData.configuration.title }}</span
                          >
                          <span class="container-text">
                            {{ staticData.configuration.description }}
                          </span>
                          <span
                            class="container-text"
                            v-if="isConfig && !isDisabled && isCancelClick"
                            >{{ staticData.configuration.description1 }}</span
                          >
                        </div>
                        <div class="col-12 xl:col-1 text-right">
                          <PrimeButton
                            label="Edit"
                            class="edit-btn"
                            :disabled="!isDisabled && isCancelClick == true"
                            @click="toggleEditMode('config')"
                          ></PrimeButton>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div>
                    <Configuration
                      v-if="lmodel !== null && vmodel.configuration"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :dealStatus="vmodel.status"
                      :vmodel="vmodel.configuration"
                      :isConfig="isConfig"
                      :modelstate="modelstate"
                      :valmodel="v$.vmodel.configuration"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      :enableAmbassadorMailsAmb="vmodel.enableAmbassadorMails"
                      @siteChange="handleSitechange"
                      @languageChange="handleLanguagechange"
                      @call="handleEditClick()"
                      :isDisabled="isDisabled"
                      @cancel="handleCancelClick()"
                      :isCancelClick="isCancelClick"
                      :voyadoApi="voyadoApi"
                      :voyadoDomain="voyadoDomain"
                    ></Configuration>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
      <!-- Targeting and Behaviour -->
      <div v-if="vmodel.configuration?.ambNeverDisplay == false">
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>

                  <div
                    :class="
                      !isDisabled && isCancelClick
                        ? 'header-edit-mode'
                        : 'head-mode'
                    "
                  >
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="aa1"
                    >
                      <div class="grid header-text">
                        <div class="col-12 xl:col-1">
                          <i class="target-icon"></i>
                        </div>
                        <div class="col-12 xl:col-10">
                          <span class="heading-text">
                            {{ staticData.target.title }}
                          </span>
                          <span class="container-text">
                            {{ staticData.target.description }}
                          </span>
                          <span
                            class="container-text"
                            v-if="isTarget && !isDisabled && isCancelClick"
                            >{{ staticData.target.description1 }}</span
                          >
                        </div>
                        <div class="col-12 xl:col-1 text-right">
                          <PrimeButton
                            label="Edit"
                            class="edit-btn"
                            :disabled="!isDisabled && isCancelClick == true"
                            @click="toggleEditMode('target')"
                          ></PrimeButton>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div>
                    <Targetingandbehaviour
                      v-if="lmodel !== null && vmodel.target"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :resultData="resultData"
                      :dealStatus="vmodel.status"
                      :vmodel="vmodel?.target"
                      :modelstate="modelstate"
                      :isTarget="isTarget"
                      :valmodel="v$.ambassador"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      :enableAmbassadorMailsAmb="vmodel.enableAmbassadorMails"
                      @call="handleEditClick()"
                      :isDisabled="isDisabled"
                      @cancel="handleCancelClick()"
                      :isCancelClick="isCancelClick"
                      :openminized="vmodel.configuration.ambOpenAsMinimized"
                    ></Targetingandbehaviour>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      <!-- Reward Page -->
      <div v-if="vmodel.configuration?.ambNeverDisplay == false">
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>

                  <div
                    :class="
                      !isDisabled && isCancelClick
                        ? 'header-edit-mode'
                        : 'head-mode'
                    "
                  >
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="IsReward"
                    >
                      <div class="grid header-text">
                        <div class="col-12 xl:col-1 toggle-button">
                          <ToggleButton
                            v-model="isNoReward"
                            onIcon="toggle-on"
                            offIcon="toggle-off"
                            class="toggle-btn"
                            @change="
                              isNoReward == true
                                ? [
                                    (vmodel.rewards.ambRewardtype = -1),
                                    (isCancelClick = false),
                                  ]
                                : (vmodel.rewards.ambRewardtype = 0)
                            "
                            :disabled="!enableRewardSection"
                          />
                        </div>
                        <div
                          class="col-12 xl:col-10"
                          :class="{
                            'error-state-set ': hasValidationError('rewards'),
                          }"
                        >
                          <span
                            class="heading-text"
                            :class="{
                              'error-state-set ': hasValidationError('rewards'),
                            }"
                            >{{ staticData.rewards.rwdtitle }}</span
                          >
                          <span class="container-text">{{
                            staticData.rewards.rwddescription
                          }}</span>
                          <span
                            class="container-text"
                            v-if="isRwd && !isDisabled && isCancelClick"
                            >{{ staticData.rewards.rwddescription1 }}</span
                          >
                        </div>
                        <div class="col-12 xl:col-1 text-right">
                          <PrimeButton
                            label="Edit"
                            class="edit-btn"
                            :disabled="
                              isNoReward ||
                              (!isDisabled && isCancelClick == true)
                            "
                            @click="toggleEditMode('rewards')"
                          ></PrimeButton>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div>
                    <Rewards
                      v-if="lmodel !== null && vmodel.rewards"
                      :vmodel="vmodel.rewards"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :dealStatus="vmodel.status"
                      :modelstate="modelstate"
                      :siteId="vmodel.configuration.setSiteId"
                      :enableRewardSection="enableRewardSection"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      :isDisabled="isDisabled"
                      :isRwd="isRwd"
                      @call="handleEditClick()"
                      @cancel="handleCancelClick()"
                      :isCancelClick="isCancelClick"
                      :valmodel="v$.vmodel.rewards"
                    ></Rewards>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      <!-- Referrals Page -->
      <div v-if="vmodel.configuration?.ambNeverDisplay == false">
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>
                  <div
                    :class="
                      !isDisabled && isCancelClick
                        ? 'header-edit-mode'
                        : 'head-mode'
                    "
                  >
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="IsReferrals"
                    >
                      <div class="grid header-text">
                        <div class="col-12 xl:col-1 toggle-button">
                          <ToggleButton
                            v-model="vmodel.referrals.ambDisablereferrals"
                            onIcon="toggle-on"
                            offIcon="toggle-off"
                            class="toggle-btn"
                          />
                        </div>
                        <div
                          class="col-12 xl:col-10"
                          :class="{
                            'error-state-set ': hasValidationError('referrals'),
                          }"
                        >
                          <span
                            class="heading-text"
                            :class="{
                              'error-state-set ':
                                hasValidationError('referrals'),
                            }"
                            >{{ staticData.referrals.title }}</span
                          >
                          <span class="container-text">{{
                            staticData.referrals.description
                          }}</span>
                          <span
                            class="container-text"
                            v-if="isReferrals && !isDisabled && isCancelClick"
                            >{{ staticData.rewards.rwddescription1 }}</span
                          >
                        </div>
                        <div class="col-12 xl:col-1 text-right">
                          <PrimeButton
                            label="Edit"
                            class="edit-btn"
                            :disabled="!isDisabled && isCancelClick == true"
                            @click="toggleEditMode('referrals')"
                          ></PrimeButton>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div>
                    <Referrals
                      v-if="lmodel !== null && vmodel.referrals"
                      :vmodel="vmodel.referrals"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :dealStatus="vmodel.status"
                      :modelstate="modelstate"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      :isDisabled="isDisabled"
                      :isReferrals="isReferrals"
                      @call="handleEditClick()"
                      @cancel="handleCancelClick()"
                      :isCancelClick="isCancelClick"
                      :valmodel="v$.vmodel.referrals"
                    ></Referrals>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      <!-- Scheduling Page -->
      <div v-if="vmodel.configuration?.ambNeverDisplay == false">
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>

                  <div
                    :class="
                      !isDisabled && isCancelClick
                        ? 'header-edit-mode'
                        : 'head-mode'
                    "
                  >
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="aa"
                    >
                      <div class="grid header-text">
                        <div class="col-12 xl:col-1">
                          <i class="schedule-icon icon"></i>
                        </div>
                        <div
                          class="col-12 xl:col-10"
                          :class="{
                            'error-state-set ':
                              hasValidationError('scheduling'),
                          }"
                        >
                          <span
                            class="heading-text"
                            :class="{
                              'error-state-set ':
                                hasValidationError('scheduling'),
                            }"
                            >{{ staticData.scheduling.title }}</span
                          >
                          <span class="container-text">{{
                            staticData.scheduling.description
                          }}</span>
                        </div>
                        <div class="col-12 xl:col-1 text-right">
                          <PrimeButton
                            label="Edit"
                            class="edit-btn"
                            :disabled="!isDisabled && isCancelClick == true"
                            @click="toggleEditMode('scheduling')"
                          ></PrimeButton>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div>
                    <Scheduling
                      v-if="lmodel !== null"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :dealStatus="vmodel.status"
                      :vmodel="vmodel.scheduling"
                      :valmodel="v$.vmodel.schedulingVal"
                      :modelstate="modelstate"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      :enableAmbassadorMailsAmb="vmodel.enableAmbassadorMails"
                      :isSchedule="isSchedule"
                      @call="handleEditClick()"
                      :isDisabled="isDisabled"
                      @cancel="handleCancelClick()"
                      :isCancelClick="isCancelClick"
                    ></Scheduling>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      <div
        v-if="
          vmodel.configuration?.ambNeverDisplay == false &&
          vmodel.referrals?.ambDisablereferrals == false
        "
      >
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>

                  <div
                    :class="
                      !isDisabled && isCancelClick
                        ? 'header-edit-mode'
                        : 'head-mode'
                    "
                  >
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="IsFriendConfig"
                    >
                      <div class="grid header-text">
                        <div class="col-12 xl:col-1">
                          <i class="settings-icon"></i>
                        </div>
                        <div class="col-12 xl:col-10">
                          <span class="heading-text">
                            {{ staticData.friendconfig.title }}
                          </span>
                          <span class="container-text">
                            {{ staticData.friendconfig.description }}
                          </span>
                          <span
                            class="container-text"
                            v-if="
                              isFriendConfig && !isDisabled && isCancelClick
                            "
                            >{{ staticData.friendconfig.description1 }}</span
                          >
                        </div>
                        <div class="col-12 xl:col-1 text-right">
                          <PrimeButton
                            label="Edit"
                            class="edit-btn"
                            :disabled="!isDisabled && isCancelClick == true"
                            @click="toggleEditMode('friendconfig')"
                          ></PrimeButton>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div>
                    <friendconfig
                      v-if="lmodel !== null && vmodel.friendconfig"
                      :vmodel="vmodel.friendconfig"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :valmodel="v$.vmodel?.friendconfig"
                      :dealStatus="vmodel.status"
                      :modelstate="modelstate"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      :isDisabled="isDisabled"
                      :isFriendConfig="isFriendConfig"
                      @call="handleEditClick()"
                      @cancel="handleCancelClick()"
                      :isCancelClick="isCancelClick"
                    ></friendconfig>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- Minimized Page -->
    <div v-if="minimizedTab && vmodel.configuration?.ambNeverDisplay == false">
      <div>
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>

                  <div>
                    <Settings
                      v-if="lmodel !== null"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :dealStatus="vmodel.status"
                      :vmodel="vmodel.minimized"
                      :modelstate="modelstate"
                      :valmodel="v$.vmodel.minimized"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      :enableAmbassadorMailsAmb="vmodel.enableAmbassadorMails"
                      :selected-device-type="
                        selectedDeviceType ? selectedDeviceType : 'desktop'
                      "
                    ></Settings>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- Maximized Page -->
    <!-- Maximized Page -->
    <div v-if="maximizedTab && vmodel.configuration?.ambNeverDisplay == false">
      <div>
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>
                  <div>
                    <maximized
                      v-if="lmodel !== null"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :dealStatus="vmodel.status"
                      :vmodel="vmodel.maximized"
                      :valmodel="v$.vmodel.maximized"
                      :modelstate="modelstate"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      :enableAmbassadorMailsAmb="vmodel.enableAmbassadorMails"
                      :selected-device-type="
                        selectedDeviceType ? selectedDeviceType : 'desktop'
                      "
                      :voyadoDynamicConsentsOptions="
                        voyadoDynamicConsentsOptions
                      "
                      :voyadoApi="voyadoApi"
                      :voyadoDomain="voyadoDomain"
                      :submitter="submitter"
                      @displayError="hasMaximizedError"
                      ref="maximizeComponent"
                    ></maximized>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- Message Tab -->
    <div v-if="messageTab && vmodel.configuration?.ambNeverDisplay == false">
      <div>
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid" style="margin-top: 180px">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>
                  <div>
                    <Messages
                      v-if="lmodel !== null && vmodel !== null"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :dealStatus="vmodel.status"
                      :vmodel="vmodel.message"
                      :modelstate="modelstate"
                      :valmodel="v$.vmodel.message"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      @openGetMeCodePopup="openGetMeCodePopup"
                      @exportUnusedCode="exportUnusedCode"
                      :enableAmbassadorMailsAmb="
                        vmodel.ambEnableAmbassadorMails
                      "
                      :selected-device-type="
                        selectedDeviceType ? selectedDeviceType : 'desktop'
                      "
                      :ambEnableDealToCustomer="
                        vmodel.configuration.ambEnableDealToCustomer
                      "
                      :enableAmbReminder="vmodel.configuration.ambEmailReminder"
                      :enableAmbMails="
                        vmodel.configuration.ambEnableAmbassadorMails
                      "
                    ></Messages>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- Return Tab -->
    <div v-if="returnTab && vmodel.configuration?.ambNeverDisplay == false">
      <div>
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid" style="margin-top: 180px">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>

                  <div>
                    <ReturnVisit
                      v-if="lmodel !== null"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :dealStatus="vmodel.status"
                      :vmodel="vmodel.returnvisit"
                      :modelstate="modelstate"
                      :valmodel="v$.ambassador"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      :enableAmbassadorMailsAmb="vmodel.enableAmbassadorMails"
                      :selected-device-type="
                        selectedDeviceType ? selectedDeviceType : 'desktop'
                      "
                    ></ReturnVisit>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- Friend Message Page -->

    <div
      v-if="
        (friendmessageTab && vmodel.configuration?.ambNeverDisplay == false) ||
        (friendmessageTab && vmodel.referrals?.ambDisablereferrals == true)
      "
    >
      <div>
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>
                  <div>
                    <friendmessage
                      v-if="lmodel !== null"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :dealStatus="vmodel.status"
                      :vmodel="vmodel.friendmessage"
                      :modelstate="modelstate"
                      :valmodel="v$.ambassador"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      :enableAmbassadorMailsAmb="vmodel.enableAmbassadorMails"
                      :selected-device-type="
                        selectedDeviceType ? selectedDeviceType : 'desktop'
                      "
                      @openGetMeCodePopup="openGetMeCodePopup"
                      @exportUnusedCode="exportUnusedCode"
                    ></friendmessage>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!-- friend Minimized Page -->
    <div
      v-if="
        friendminimizedTab && vmodel.configuration?.ambNeverDisplay == false
      "
    >
      <div>
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>
                  <div>
                    <friendminimized
                      v-if="lmodel !== null"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :dealStatus="vmodel.status"
                      :vmodel="vmodel.friendminimized"
                      :modelstate="modelstate"
                      :valmodel="v$.ambassador"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      :enableAmbassadorMailsAmb="vmodel.enableAmbassadorMails"
                      :selected-device-type="
                        selectedDeviceType ? selectedDeviceType : 'desktop'
                      "
                    ></friendminimized>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!-- Friend Maximized Page -->
    <div
      v-if="frdmaximizedTab && vmodel.configuration?.ambNeverDisplay == false"
    >
      <div>
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>
                  <div>
                    <friendmaximized
                      v-if="lmodel !== null"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :dealStatus="vmodel.status"
                      :vmodel="vmodel.friendmaximized"
                      :modelstate="modelstate"
                      :valmodel="v$.vmodel.friendmaximized"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      :enableAmbassadorMailsAmb="vmodel.enableAmbassadorMails"
                      :selected-device-type="
                        selectedDeviceType ? selectedDeviceType : 'desktop'
                      "
                      :voyadoDynamicConsentsOptions="
                        voyadoDynamicConsentsOptions
                      "
                      @openGetMeCodePopup="openGetMeCodePopup"
                      @exportUnusedCode="exportUnusedCode"
                      :voyadoApi="voyadoApi"
                      :voyadoDomain="voyadoDomain"
                      :submitter="submitter"
                      @displayError="hasFrdMaximizedError"
                      ref="frdMaximizeComponent"
                    ></friendmaximized>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- Friend Return Visit Page -->
    <div
      v-if="
        friendreturnvisitTab && vmodel.configuration?.ambNeverDisplay == false
      "
    >
      <div>
        <section class="wrapperAdd mid-width">
          <div class="grid">
            <div class="col-12">
              <section class="card" v-if="vmodel != null">
                <div class="card-mid">
                  <div style="display: contents">
                    <a
                      href="javascript:;"
                      style="color: unset; text-decoration: none"
                      id="ab"
                    ></a>
                  </div>
                  <div>
                    <friendreturnvisit
                      v-if="lmodel !== null"
                      :lmodel="lmodel"
                      :dmodel="dmodel"
                      :dealStatus="vmodel.status"
                      :vmodel="vmodel.friendreturnvisit"
                      :modelstate="modelstate"
                      :valmodel="v$.ambassador"
                      :customerCampaignDealyDaysError="
                        customerCampaignDealyDaysError
                      "
                      :enableAmbassadorMailsAmb="vmodel.enableAmbassadorMails"
                      :selected-device-type="
                        selectedDeviceType ? selectedDeviceType : 'desktop'
                      "
                    ></friendreturnvisit>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
    </div>
    <Dialog
      :header="status"
      position="top "
      modal
      v-model:visible="ShowStatusChangePopup"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '30vw' }"
    >
      <span>{{ statuschange_message }}</span>
      <template #footer>
        <PrimeButton
          label="Cancel"
          class="btn-cancel"
          @click="onCancel"
        ></PrimeButton>
        <PrimeButton
          label="Yes, delete the Deal"
          :class="
            this.status == 'Pause'
              ? 'btn btn-outline-warning'
              : 'btn btn-outline-success'
          "
          @click="statusChange()"
          >Yes, {{ this.status }} the deal</PrimeButton
        >
      </template>
    </Dialog>
  </div>
</template>

<script>
import configuration from "@/views/ManageDealUpdate/Settings/configuration.vue";
import targetingandbehaviour from "@/views/ManageDealUpdate/Settings/targetingandbehaviour.vue";
import rewards from "@/views/ManageDealUpdate/Settings/rewards.vue";
import scheduling from "@/views/ManageDealUpdate/Settings/scheduling.vue";
import friendConfig from "@/views/ManageDealUpdate/Settings/friendconfig.vue";
import referrals from "@/views/ManageDealUpdate/Settings/referrals.vue";
import returnvisit from "@/views/ManageDealUpdate/Visit/returnvisit.vue";
import friendmessage from "@/views/ManageDealUpdate/Message/friendmessage.vue";
import friendreturnvisit from "@/views/ManageDealUpdate/Visit/friendreturnvisit.vue";
import friendmaximized from "@/views/ManageDealUpdate/Maximized/friendmaximized.vue";
import friendminimized from "@/views/ManageDealUpdate/Minimized/friendminimized.vue";
import DataLayerService from "@/services/data-layer.service.js";
import staticData from "@/staticdata/static.json";
import settings from "@/views/ManageDealUpdate/Minimized/minimized.vue";
import maximized from "@/views/ManageDealUpdate/Maximized/maximized.vue";
import messages from "@/views/ManageDealUpdate/Message/message.vue";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
// import findReplace from "@/views/ManageDealUpdate/findandreplace.vue";
import { useVuelidate } from "@vuelidate/core";
import ManageResponseUpdateFactory from "@/factories/managedealupdate-response";
import ManageDealUpdateNewPayload from "@/factories/managedealupdate-payload";
import { isValidLandingURL } from "@/services/validators";
import Dialog from "primevue/dialog";
import axios from "axios";
import Store from "@/store/index";
const baseURL = Store.state.apiURL;

import {
  required,
  requiredIf,
  integer,
  minValue,
  maxValue,
} from "@vuelidate/validators";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    Configuration: configuration,
    Targetingandbehaviour: targetingandbehaviour,
    Rewards: rewards,
    Scheduling: scheduling,
    friendconfig: friendConfig,
    Referrals: referrals,
    Maximized: maximized,
    Settings: settings,
    Messages: messages,
    ReturnVisit: returnvisit,
    friendmessage: friendmessage,
    friendmaximized: friendmaximized,
    friendreturnvisit: friendreturnvisit,
    friendminimized: friendminimized,
    // FindAndReplace: findReplace,
    TabView,
    TabPanel,
    Dialog,
  },
  data() {
    return {
      submitter: "",

      startDate: null,
      displayPublish: false,
      displaySelectDate: false,
      referrals: null,
      isReferrals: false,
      isReferralSec: false,
      friendconfig: null,
      isFriendConfig: false,
      ShowStatusChangePopup: false,
      selectedPreview: "",
      isNoReward: false,
      enableRewardSection: true,
      voyadoDynamicConsentsOptions: [],
      hasMaximizeErr: false,
      hasFrdMaximizeErr: false,
      ShowChangesCheck: false,
      voyadoDomain: "",
      voyadoApi: "",
      configuration: null,
      maximized: null,
      hasErr: false,
      hasErrFrnd: false,
      status: "",
      isEditMode: false,
      configSave: false,
      rwdSave: false,
      targetSave: false,
      scheduleSave: false,
      isConfig: false,
      isDisabled: true,
      isTarget: false,
      isSchedule: false,
      isCancelClick: false,
      isRwd: false,
      isEnable: false,
      settingTab: true,
      minimizedTab: false,
      maximizedTab: false,
      messageTab: false,
      frdmaximizedTab: false,
      returnTab: false,
      friendmessageTab: false,
      friendreturnvisitTab: false,
      friendminimizedTab: false,
      selectedDeviceType: "",
      staticData: staticData,
      ShowGetMeCodePopup: false,
      isTriggersDone: false,
      isEmailCopy: false,
      vmodel: {},
      lmodel: {},
      dmodel: {},
      modelstate: {},
      customerCampaignDealyDaysError: null,
      id: this.$route.params.id,
      items: [{ label: "Start" }, { label: "Onsite" }],
      schedulingVal: null,
      rewards: null,
      message: null,
      minimized: null,
      friendmaximized: null,
      dealId: "",
      dealStatus: null,
      isRedealText: false,
      desktopSelect: true,
      mobileSelect: false,
      showPopup: false,
      inputTextValue: "",
      searchCount: "",
      ShowFindPopup: false,
      displayReplace: false,
      replaceTextValue: "",
      replaceTextLbl: "",
      resultData: [],
      setItems: [
        {
          label: "Change Log(s)",
          command: () => {
            this.$router.push({
              name: "Changelog",
              params: { id: this.id },
            });
          },
        },
        {
          label: "Export to CSV",
        },
        {
          label: "Find",
          command: () => {
            this.ShowFindPopup = true;
          },
        },
      ],
    };
  },
  validations() {
    return {
      vmodel: {
        configuration: {
          setName: { required },
          setLanguage: { required },
          setSiteId: { required },
          ambConversionDays: {
            integer,
            minValue: minValue(0),
            maxValue: maxValue(999),
          },
          ambPriority: {
            integer,
          },
          ambRUAR: {
            isValidLandingURL,
          },
          ambreferralSessionBlockTime: {
            integer,
            minValue: minValue(0),
            maxValue: maxValue(365),
          },
        },

        friendconfig: {
          setLandingPageUrl: {
            requiredIf: requiredIf(() => {
              return this.vmodel.friendconfig?.setDealLandingPage === 0;
            }),
            isValidLandingURL,
          },
          friConversionDays: { integer },
          friReferralSessionBlockTime: {
            integer,
            minValue: minValue(0),
            maxValue: maxValue(365),
          },
          friRUAR: {
            isValidLandingURL,
          },
        },

        referrals: {
          ambFlowType: { required },
          messengerTitle: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasFacebookChannel;
            }),
          },
          messengerText: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasFacebookChannel;
            }),
          },
          whatsappChannelBody: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasWhatsappChannel;
            }),
          },
          shareableLinkTitle: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasSharebleLinkChannel;
            }),
          },
          shareableLinkDesc: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasSharebleLinkChannel;
            }),
          },
          twitterChannelTitle: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasTwitterChannel;
            }),
          },
          twitterChannelDesc: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasTwitterChannel;
            }),
          },
          twitterChannelBody: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasTwitterChannel;
            }),
          },
          lineChannelTitle: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasLineChannel;
            }),
          },
          lineChannelDesc: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasLineChannel;
            }),
          },
          lineChannelBody: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasLineChannel;
            }),
          },
          kakaotalkChannelWidgetTitle: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasKakaotalkChannel;
            }),
          },
          kakaotalkChannelWidgetDesc: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasKakaotalkChannel;
            }),
          },
          kakaotalkChannelTitle: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasKakaotalkChannel;
            }),
          },
          kakaotalkChannelButtonText: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasKakaotalkChannel;
            }),
          },
          kakaotalkChannelBody: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasKakaotalkChannel;
            }),
          },
          webShareTitle: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasWebShareChannel;
            }),
          },
          webShareBody: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasWebShareChannel;
            }),
          },
          emailChannelSubject: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasNativeMailChannel;
            }),
          },
          emailChannelBody: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasNativeMailChannel;
            }),
          },
          pageShareDescription: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasPageShareChannel;
            }),
          },
          pageShareDescriptionPointer: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasPageShareChannel;
            }),
          },
          skypeTitle: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasSkypeChannel;
            }),
          },
          skypeText: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasSkypeChannel;
            }),
          },
          wechatdescription: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasWeChatChannel;
            }),
          },
          wechatdescriptionpointer: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasWeChatChannel;
            }),
          },
          qRheader: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasQRChannel;
            }),
          },
          qRbody: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasQRChannel;
            }),
          },
          discorddescription: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasDiscordChannel;
            }),
          },
          discorddescriptionpointer: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasDiscordChannel;
            }),
          },
          signaldescription: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasSignalChannel;
            }),
          },
          signaldescriptionpointer: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasSignalChannel;
            }),
          },
          instagramdescription: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasInstagramChannel;
            }),
          },
          instagramdescriptionpointer: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasInstagramChannel;
            }),
          },
          trueCallerDescription: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasTrueCallerChannel;
            }),
          },
          trueCallerDescriptionPointer: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasTrueCallerChannel;
            }),
          },
          telegramChannelBody: {
            requiredIf: requiredIf(() => {
              return this.vmodel.referrals.setHasTelegramChannel;
            }),
          },
        },

        friendmaximized: {
          friCustomTextFieldLabel: {
            requiredIf: requiredIf(() => {
              return this.vmodel.friendmaximized.friEnableCustomTextField;
            }),
          },
          friCustomTextField: {
            requiredIf: requiredIf(() => {
              return this.vmodel.friendmaximized.friEnableCustomTextField;
            }),
          },
          friciFieldName: {
            requiredIf: requiredIf(() => {
              return this.vmodel.friendmaximized.friciFieldValue;
            }),
          },
          friciFieldValue: {
            requiredIf: requiredIf(() => {
              return this.vmodel.friendmaximized.friciFieldName;
            }),
          },
        },

        message: {
          ambCustomerRemindBeforeDays: {
            required,
            integer,
            minValue: minValue(0),
            maxValue: maxValue(
              this.vmodel != null &&
                this.vmodel.rewards != null &&
                this.vmodel.rewards != undefined &&
                this.vmodel.rewards.ambCustomerRemindBeforeDays != 0 &&
                (this.vmodel.rewards.ambCustomerIsTimeSpanCoupon == true
                  ? this.vmodel.rewards.ambCustomerTimeSpanDaysAmount - 1
                  : Math.ceil(
                      (new Date(
                        this.vmodel.rewards.ambcustomerCodeExpirationDate
                      ).getTime() -
                        new Date().getTime()) /
                        (1000 * 3600 * 24)
                    ))
            ),
          },
          ambCustomerSecondRemindBeforeDays: {
            required,
            integer,
            minValue: minValue(0),
            maxValue: maxValue(
              this.vmodel != null &&
                this.vmodel.rewards != null &&
                this.vmodel.rewards.ambCustomerSecondRemindBeforeDays != 0
                ? this.vmodel.rewards.ambCustomerRemindBeforeDays != null
                  ? this.vmodel.rewards.ambCustomerRemindBeforeDays - 1
                  : this.vmodel != null &&
                    this.vmodel.rewards != null &&
                    this.vmodel.rewards.ambCustomerIsTimeSpanCoupon == true
                  ? this.vmodel.rewards.ambCustomerTimeSpanDaysAmount - 1
                  : Number.MAX_SAFE_INTEGER
                : 0
            ),
          },
          ambCustomerCampaignDealyDays: { integer, minValue: minValue(0) },
        },
        rewards: {
          ambAmbassadorRewardTime: { required },
          ambCustomerTimeSpanDaysAmount: {
            integer,
            minValue: minValue(0),
            maxValue: maxValue(999),
          },
          ambCustomerStaticCode: {
            requiredIf: requiredIf(() => {
              return (
                this.vmodel.postEvent != "draft" &&
                !this.vmodel.rewards.ambCustomerUseDynamicCodes &&
                this.vmodel.configuration.ambEnableDealToCustomer &&
                !this.vmodel.rewards.ambisVoyadoPromo &&
                this.vmodel.rewards.ambRewardtype == 0
              );
            }),
          },
          ambCustomerDynamicCodesActualFilename: {
            requiredIf: requiredIf(() => {
              return this.vmodel.rewards.ambRewardtype == 1;
            }),
          },
          ambVoyadoPromoId: {
            requiredIf: requiredIf(() => {
              return this.vmodel.rewards.ambRewardtype == 2;
            }),
          },
          ambvoyadobonuspoint: {
            requiredIf: requiredIf(() => {
              return this.vmodel.rewards.ambRewardtype == 3;
            }),
          },
          ambCustomerLowCodeLimit: {
            requiredIf: requiredIf(() => {
              return this.vmodel.rewards.ambCustomerUseDynamicCodes;
            }),
            integer,
            minValue: minValue(0),
          },
          ambCustomerLowCodeAlertLimit: {
            requiredIf: requiredIf(() => {
              return this.vmodel.rewards.ambCustomerUseDynamicCodes;
            }),
            integer,
            minValue: minValue(0),
          },
          amboutofcodemsgtitle: {
            requiredIf: requiredIf(() => {
              return this.vmodel.rewards.ambshowdeniedoutofcodemsg;
            }),
          },
          amboutofcodemsgbody: {
            requiredIf: requiredIf(() => {
              return this.vmodel.rewards.ambshowdeniedoutofcodemsg;
            }),
          },
        },
        minimized: {
          customerPopupMinimizePosition: { required },
          minwidpadMobileB: {
            integer,
            minValue: minValue(0),
            maxValue: maxValue(999),
          },
          minwidpadMobileL: {
            integer,
            minValue: minValue(0),
            maxValue: maxValue(999),
          },
        },
        maximized: {
          ambCustomTextFieldLabel: {
            requiredIf: requiredIf(() => {
              return this.vmodel.maximized.ambEnableCustomTextField;
            }),
          },
          ambCustomTextField: {
            requiredIf: requiredIf(() => {
              return this.vmodel.maximized.ambEnableCustomTextField;
            }),
          },

          ciErrorHeader: {
            requiredIf: requiredIf(() => {
              return this.vmodel.maximized.ciErrorMessage;
            }),
          },
          ciErrorMessage: {
            requiredIf: requiredIf(() => {
              return this.vmodel.maximized.ciErrorHeader;
            }),
          },
          ambciFieldName: {
            requiredIf: requiredIf(() => {
              return this.vmodel.maximized.ambciFieldValue;
            }),
          },
          ambciFieldValue: {
            requiredIf: requiredIf(() => {
              return this.vmodel.maximized.ambciFieldName;
            }),
          },

          ambCustomerInfoTargetChooseBtn: {
            requiredIf: requiredIf(() => {
              return this.vmodel.configuration.setTargetCampaignURL != "";
            }),
          },
          fontsizeformsg: {
            integer,
            minValue: minValue(0),
            maxValue: maxValue(999),
          },
          fontsizefortitle: {
            integer,
            minValue: minValue(0),
            maxValue: maxValue(999),
          },
          fontsizeforcta: {
            integer,
            minValue: minValue(0),
            maxValue: maxValue(999),
          },
          setCTAbuttonwidth: {
            integer,
            minValue: minValue(0),
            maxValue: maxValue(300),
          },
          widgetCornerRound: {
            integer,
            minValue: minValue(0),
            maxValue: maxValue(999),
          },
          widgetShadowBlur: {
            integer,
            minValue: minValue(0),
            maxValue: maxValue(999),
          },

          ambcustomerCheckoutWelcomeTitle: { required },
          ambcustomerCheckoutWelcomeBody: { required },
        },
        publishStartDate: {
          startDate: {
            requiredIf: requiredIf(() => {
              return this.startDate == null;
            }),
          },
        },
        schedulingVal: {
          pubStartDate: {
            requiredIf: requiredIf(() => {
              return (
                this.vmodel.postEvent != "draft" &&
                this.vmodel.scheduling.pubStartDate == null
              );
            }),
          },
          pauseDate: () => {
            if (
              (this.vmodel.status == 0 || this.vmodel.status == 1) &&
              (this.vmodel.postEvent === "pause" ||
                this.vmodel.postEvent === "update")
            ) {
              if (this.vmodel.scheduling.pubPauseDate != null) {
                var _pauseDate = this.vmodel.scheduling.pubPauseDate;
                if (this.vmodel.scheduling.pubStartDate != null) {
                  var _startDate = this.vmodel.scheduling.pubStartDate;
                  if (_pauseDate < _startDate) {
                    return false;
                  }
                }
                if (this.vmodel.scheduling.pubDealEndDate != null) {
                  var _endDate = this.vmodel.scheduling.pubDealEndDate;
                  if (_endDate < _pauseDate) {
                    return false;
                  }
                }
              } else {
                return true;
              }
            }
            return true;
          },
          pubRePublishDate: () => {
            if (this.vmodel.status == 4) {
              if (this.vmodel.scheduling.pubRePublishDate != null) {
                var _rePublishDate = this.vmodel.scheduling.pubRePublishDate;
                if (this.vmodel.scheduling.pubPauseDate != null) {
                  var _pauseDate = this.vmodel.scheduling.pubPauseDate;
                  if (_rePublishDate < _pauseDate) {
                    return false;
                  }
                }
                if (this.vmodel.scheduling.pubDealEndDate != null) {
                  var _endDate = this.vmodel.scheduling.pubDealEndDate;
                  if (_endDate < _rePublishDate) {
                    return false;
                  }
                }
              }
            }
            return true;
          },
          pubEndDate: () => {
            if (this.vmodel.status !== 2) {
              if (
                this.vmodel.scheduling.pubEndDate == null ||
                this.vmodel.scheduling.pubEndDate == undefined ||
                this.vmodel.scheduling.pubEndDate == ""
              ) {
                return true;
              } else {
                var d = new Date();
                d.setHours(0, 0, 0, 0);
                var _endDate = this.vmodel.scheduling.pubEndDate;
                if (_endDate < d) {
                  return false;
                }
                if (this.vmodel.scheduling.pubStartDate != null) {
                  var _startDate = this.vmodel.scheduling.pubStartDate;
                  if (_startDate > _endDate) {
                    return false;
                  }
                }
                if (this.vmodel.scheduling.pubRePublishDate != null) {
                  var _rePublishDate = this.vmodel.scheduling.pubRePublishDate;
                  if (_rePublishDate > _endDate) {
                    return false;
                  }
                }
              }
            }
            return true;
          },
        },
      },
    };
  },
  computed: {
    checkPathTriggerSelected() {
      return this.checkTriggerSelected([0, 1, 6]);
    },
    checkCookieTriggerSelected() {
      return this.checkTriggerSelected([2, 3]);
    },
    checkLocalstorageTriggerSelected() {
      return this.checkTriggerSelected([4, 5]);
    },
    previewoptions() {
      return [
        {
          text: "View Preview",
          value: "aa",
        },
        {
          text: "Ambassador Widget",
          value: "AW",
        },
        {
          text: "Friend Widget",
          value: "FW",
        },
        {
          text: "Ambassador Recall Widget",
          value: "ARW",
        },
        {
          text: "Friend Recall Widget",
          value: "FRW",
        },
      ];
    },
    // isSearchDisabled() {
    //   return !this.inputTextValue;
    // },
    isReplaceButtonDisabled() {
      return !this.inputTextValue;
    },
  },

  async mounted() {
    if (this.$route.name == "ManageDealUpdateById") {
      if (this.id != null && this.id != undefined) {
        await this.externalval();
        await this.getDataById();
        await this.getStaticData();
        this.enableRewardSection = false;
      }
    } else if (this.$route.name == "ManageDealUpdateCreate") {
      await this.externalval();
      await this.getNewOnsiteMsg();
      this.enableRewardSection = true;

      // await this.getStaticData();
    }
    if (this.vmodel?.rewards?.ambRewardtype == -1) {
      this.isNoReward = true;
    } else {
      this.isNoReward = false;
    }
    window.scrollTo(0, 0);
  },
  watch: {
    "vmodel.configuration.setSiteId": function (newValue) {
      if (this.$route.name !== "ManageDealUpdateCreate") {
        this.voyadoInsite(newValue);
      }
    },
  },
  methods: {
    async externalval() {
      this.loader = true;
      var accessToken = Store.state.cognitoInfo.token;
      var jwtHeader = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          CompanyId:
            Store.state.cognitoInfo.companyid == undefined ||
            Store.state.cognitoInfo.companyid == null ||
            Store.state.cognitoInfo.companyid == "undefined" ||
            Store.state.cognitoInfo.companyid == "null"
              ? ""
              : Store.state.cognitoInfo.companyid,
          crossDomain: true,
        },
      };
      await axios
        .get(`${baseURL}/dealtriggers/BindDealTriggerDropDowns`, jwtHeader)
        .then((result) => {
          this.resultData = result;
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
        })
        .finally(() => {
          this.loader = false;
        });
    },
    GetDynamicConsents() {
      const apiUrl = `/site/getdynamicconsents?apikey=${this.voyadoApi}&domain=${this.voyadoDomain}&language=${this.vmodel.configuration.setLanguage}`;
      DataLayerService.get(apiUrl).then((result) => {
        if (result !== null && result !== undefined && result != []) {
          this.voyadoDynamicConsentsOptions = result;
        }
      });
    },
    handleLanguagechange() {
      this.GetDynamicConsents();
      if (!this.$route.params.id) {
        this.getLanguage();
      }
    },
    async handleSitechange() {
      await DataLayerService.getById(
        "/site/getSiteConfiguration",
        this.vmodel.configuration.setSiteId
      ).then((result) => {
        this.vmodel.rewards.ambshowVoyadoPromo = result.success;
        this.voyadoApi = result.campaignView.settings.voyadoApi;
        this.voyadoDomain = result.campaignView.settings.voyadoDomain;
        // this.vmodel.showVoyadoPromo = result.success;
        if (
          result.success === false &&
          this.vmodel.rewards.ambRewardtype === 2
        ) {
          this.vmodel.rewards.ambRewardtype = 0;
        }

        if (
          result.success === false &&
          this.vmodel.rewards.ambRewardtype === 2
        ) {
          this.vmodel.rewards.ambRewardtype = 0;
        }
      });

      let filterData =
        this.dmodel.draftOnSiteDropdownList.siteLanguageMappingList.filter(
          (a) => a.value == this.vmodel.configuration.setSiteId
        );

      if (filterData != null && filterData.length > 0) {
        this.vmodel.configuration.setLanguage = filterData[0].text;

        this.handleLanguagechange();
      }
    },

    getLanguage() {
      if (
        this.vmodel.configuration.setLanguage !== null &&
        this.vmodel.configuration.setLanguage !== undefined &&
        this.vmodel.configuration.setLanguage !== ""
      ) {
        const Url = `/Deal/GetValuesByLanguage/${this.vmodel.configuration.setLanguage}`;

        DataLayerService.get(Url).then((result) => {
          // let vmodelData = result.viewModel;

          if (result.viewModel != null && result.viewModel != undefined) {
            this.vmodel.minimized.ambCustomerPopupMinimizeTitle =
              result.viewModel.ambassador.customerPopupMinimizeTitle;

            this.vmodel.minimized.ambCustomerPopupMinimizeTitleMobile =
              result.viewModel.ambassador.customerPopupMinimizeTitleMobile;

            this.vmodel.minimized.ambCustomerPopupMinTabCodeDel =
              result.viewModel.ambassador.customerPopupMinTabCodeDel;

            this.vmodel.minimized.ambCustomerPopupMinTabCodeDelMobile =
              result.viewModel.ambassador.customerPopupMinTabCodeDelMobile;

            this.vmodel.maximized.fontsizeformsg =
              result.viewModel.settings.fontsizeformsg;

            this.vmodel.maximized.setfontsizefortitle =
              result.viewModel.settings.fontsizefortitle;

            this.vmodel.maximized.fontsizeforcta =
              result.viewModel.settings.fontsizeforcta;

            this.vmodel.setbtnvp = result.viewModel.settings.btnvp;

            this.vmodel.setbtnhp = result.viewModel.settings.btnhp;

            this.vmodel.setImageBorder = result.viewModel.settings.imageBorder;

            this.vmodel.maximized.ambCustomerInfoBlockButtonLabel =
              result.viewModel.ambassador.customerInfoBlockButtonLabel;

            this.vmodel.maximized.ambMailScreenButtonLable =
              result.viewModel.ambassador.mailScreenButtonLable;

            this.vmodel.maximized.ambCustomerInfoChooseWay =
              result.viewModel.ambassador.customerInfoChooseWay;

            this.vmodel.maximized.ambCustomerInfoDoneButtonLabel =
              result.viewModel.ambassador.customerInfoDoneButtonLabel;

            this.vmodel.maximized.ambassadorCloseButton =
              result.viewModel.ambassador.ambassadorCloseButton;

            this.vmodel.maximized.ambassadorSLCTAButton =
              result.viewModel.ambassador.ambassadorSLCTAButton;

            this.vmodel.maximized.ambCustomerInfoTargetChooseBtn =
              result.viewModel.ambassador.customerInfoTargetChooseBtn;

            this.vmodel.maximized.setAmbassadorOptInYes =
              result.viewModel.settings.ambassadorOptInYes;

            this.vmodel.maximized.setAmbassadorOptInNo =
              result.viewModel.settings.ambassadorOptInNo;

            this.vmodel.maximized.ambassadorTermConsentText =
              result.viewModel.ambassador.ambassadorTermConsentText;

            this.vmodel.maximized.ambVoyadoMemberType =
              result.viewModel.ambassador.voyadoMemberType;

            this.vmodel.maximized.ambcustomerCheckoutWelcomeTitle =
              result.viewModel.ambassador.customerCheckoutWelcomeTitle;

            this.vmodel.maximized.ambcustomerCheckoutWelcomeBody =
              result.viewModel.ambassador.customerCheckoutWelcomeBody;

            this.vmodel.returnvisit.ambCustomerThanksScreenTitle =
              result.viewModel.ambassador.customerThanksScreenTitle;

            this.vmodel.returnvisit.ambCustomerThanksScreenBody =
              result.viewModel.ambassador.customerThanksScreenBody;

            this.vmodel.returnvisit.ambCustomerCouponScreenTitle =
              result.viewModel.ambassador.customerCouponScreenTitle;

            this.vmodel.returnvisit.ambCustomerCouponScreenTerms =
              result.viewModel.ambassador.customerCouponScreenTerms;

            this.vmodel.returnvisit.ambCustomerCouponScreenBody =
              result.viewModel.ambassador.customerCouponScreenBody;

            this.vmodel.returnvisit.setCouponExpiredHeader =
              result.viewModel.settings.couponExpiredHeader;

            this.vmodel.returnvisit.setCouponExpiredMessage =
              result.viewModel.settings.couponExpiredMessage;

            this.vmodel.returnvisit.setDealExpiredHeader =
              result.viewModel.settings.dealExpiredHeader;

            this.vmodel.returnvisit.setDealExpiredMessage =
              result.viewModel.settings.dealExpiredMessage;

            this.vmodel.message.ambSaveCodesubject =
              result.viewModel.ambassador.saveCode.subject;

            this.vmodel.message.ambSaveCodesubhead =
              result.viewModel.ambassador.saveCode.subhead;

            this.vmodel.message.ambSaveCodebody =
              result.viewModel.ambassador.saveCode.body;

            this.vmodel.message.ambSaveCodectabutton =
              result.viewModel.ambassador.saveCode.ctabutton;

            this.vmodel.message.ambFirstRemsubject =
              result.viewModel.ambassador.firstReminder.subject;

            this.vmodel.message.ambFirstRemsubhead =
              result.viewModel.ambassador.firstReminder.subhead;

            this.vmodel.message.ambFirstRembody =
              result.viewModel.ambassador.firstReminder.body;

            this.vmodel.message.ambFirstRemctabutton =
              result.viewModel.ambassador.firstReminder.ctabutton;

            this.vmodel.message.ambSecRemsubject =
              result.viewModel.ambassador.secondReminder.subject;

            this.vmodel.message.ambSecRemsubhead =
              result.viewModel.ambassador.secondReminder.subhead;

            this.vmodel.message.ambSecRembody =
              result.viewModel.ambassador.secondReminder.body;

            this.vmodel.message.ambSecRemctabutton =
              result.viewModel.ambassador.secondReminder.ctabutton;

            // this.vmodel.refSetting.ambassadorInfoTitle =
            //   result.viewModel.ambassador.ambassadorInfoTitle;
            // this.vmodel.refSetting.optionScreenChannelText =
            //   result.viewModel.ambassador.optionScreenChannelText;
            // this.vmodel.refSetting.pickAnotherFriendText =
            //   result.viewModel.ambassador.pickAnotherFriendText; //refsetting not found

            this.vmodel.friYourCodeWillShowHereText =
              result.viewModel.friend.yourCodeWillShowHereText;

            this.vmodel.friendminimized.friendPopupMinimizeTitle =
              result.viewModel.friend.friendPopupMinimizeTitle;

            this.vmodel.friendPopupMinimizeTitleMobile =
              result.viewModel.friend.friendPopupMinimizeTitleMobile;

            this.vmodel.friendmaximized.friendFirstSendButton =
              result.viewModel.friend.friendFirstSendButton;

            this.vmodel.friendmaximized.friendFirstCloseButton =
              result.viewModel.friend.friendFirstCloseButton;

            this.vmodel.friendmaximized.friendGetYourCodeButton =
              result.viewModel.friend.friendGetYourCodeButton;

            this.vmodel.friendmaximized.friSaveRemindMeButton =
              result.viewModel.friend.saveRemindMeButton;

            this.vmodel.friendmaximized.friSaveOfferForLaterText =
              result.viewModel.friend.saveOfferForLaterText;

            this.vmodel.friendmaximized.friendCouponScreenBodySmall =
              result.viewModel.friend.friendCouponScreenBodySmall;

            this.vmodel.friendmaximized.friendCouponScreenTerms =
              result.viewModel.friend.friendCouponScreenTerms;

            this.vmodel.friendmaximized.setFriendOptInYes =
              result.viewModel.settings.friendOptInYes;

            this.vmodel.friendmaximized.setFriendOptInNo =
              result.viewModel.settings.friendOptInNo;

            this.vmodel.friendmaximized.friendTermConsentText =
              result.viewModel.friend.friendTermConsentText;

            this.vmodel.friendmaximized.friVoyadoMemberType =
              result.viewModel.friend.voyadoMemberType;

            this.vmodel.friCodeLimitReachedHeader =
              result.viewModel.friend.codeLimitReachedHeader;

            this.vmodel.friCodeLimitReachedMessage =
              result.viewModel.friend.codeLimitReachedMessage;

            this.vmodel.friendCouponScreenTitle =
              result.viewModel.friend.friendCouponScreenTitle;

            this.vmodel.friendCouponScreenBody =
              result.viewModel.friend.friendCouponScreenBody;

            this.vmodel.friendreturnvisit.friendThanksScreenTitle =
              result.viewModel.friend.friendThanksScreenTitle;

            this.vmodel.friendreturnvisit.friendThanksScreenBody =
              result.viewModel.friend.friendThanksScreenBody;

            // this.vmodel.friendEmailCopy.friendEmailCopySaveCodesubject =
            //   result.viewModel.friend.saveCode.subject; // field not found
            // this.vmodel.friendEmailCopy.friendEmailCopySaveCodesubhead =
            //   result.viewModel.friend.saveCode.subhead; // field not found
            // this.vmodel.friendEmailCopy.friendEmailCopySaveCodebody =
            //   result.viewModel.friend.saveCode.body; // field not found
            // this.vmodel.friendEmailCopy.friendEmailCopySaveCodectabutton =
            //   result.viewModel.friend.saveCode.ctabutton; // field not found
            // this.vmodel.friendEmailCopy.firstRemindersubject =
            //   result.viewModel.friend.firstReminder.subject; // field not found
            // this.vmodel.friendEmailCopy.firstRemindersubhead =
            //   result.viewModel.friend.firstReminder.subhead; //field not found
            // this.vmodel.friendEmailCopy.firstReminderbody =
            //   result.viewModel.friend.firstReminder.body; //field not found
            // this.vmodel.friendEmailCopy.firstReminderctabutton =
            //   result.viewModel.friend.firstReminder.ctabutton;
            // this.vmodel.friendEmailCopy.secondRemindersubject =
            //   result.viewModel.friend.secondReminder.subject;
            // this.vmodel.friendEmailCopy.secondRemindersubhead =
            //   result.viewModel.friend.secondReminder.subhead;
            // this.vmodel.friendEmailCopy.secondReminderbody =
            //   result.viewModel.friend.secondReminder.body;
            // this.vmodel.friendEmailCopy.secondReminderctabutton =
            //   result.viewModel.friend.secondReminder.ctabutton; // field not found
          }
        });
      }
    },

    handleSiteIdChange() {
      this.voyadoInsite(this.vmodel.configuration.setSiteId);
    },

    async getNewOnsiteMsg() {
      await DataLayerService.get("/OnSite/GetOnsiteMessage/1").then(
        (result) => {
          const modelData = result.viewModel;
          this.vmodel = modelData;
          this.lmodel = result.labelModel;
          this.dmodel = result.dropdownListModel;

          this.vmodel =
            ManageResponseUpdateFactory.createFromJsonArray(modelData);

          this.vmodel.maximized.popupButtonTextColor = this.rgbaToHex(
            this.vmodel.maximized.popupButtonTextColor,
            "popupButtonTextColor"
          );

          this.vmodel.maximized.popupButtonBackgroundColor = this.rgbaToHex(
            this.vmodel.maximized.popupButtonBackgroundColor,
            "popupButtonBackgroundColor"
          );

          this.vmodel.maximized.widgetBackgroundColor = this.rgbaToHex(
            this.vmodel.maximized.widgetBackgroundColor,
            "widgetBackgroundColor"
          );

          this.vmodel.maximized.setTextColor = this.rgbaToHex(
            this.vmodel.maximized.setTextColor,
            "setTextColor"
          );

          this.vmodel.minimized.minwidPopupButtonTextColor = this.rgbaToHex(
            this.vmodel.minimized.minwidPopupButtonTextColor,
            "minwidPopupButtonTextColor"
          );

          this.vmodel.minimized.minwidPopupButtonBackgroundColor =
            this.rgbaToHex(
              this.vmodel.minimized.minwidPopupButtonBackgroundColor,
              "minwidPopupButtonBackgroundColor"
            );

          this.vmodel.minimized.setWidgetShadowColor = this.rgbaToHex(
            this.vmodel.minimized.setWidgetShadowColor,
            "setWidgetShadowColor"
          );

          this.vmodel.friendminimized.minwidPopupButtonBackgroundColor =
            this.rgbaToHex(
              this.vmodel.friendminimized.minwidPopupButtonBackgroundColor,
              "minwidPopupButtonBackgroundColor"
            );

          this.vmodel.friendminimized.minwidPopupButtonTextColor =
            this.rgbaToHex(
              this.vmodel.friendminimized.minwidPopupButtonTextColor,
              "minwidPopupButtonTextColor"
            );

          this.vmodel.friendminimized.widgetShadowColor = this.rgbaToHex(
            this.vmodel.friendminimized.widgetShadowColor,
            "widgetShadowColor"
          );

          this.vmodel.friendminimized.popupButtonBackgroundColor =
            this.rgbaToHex(
              this.vmodel.friendminimized.popupButtonBackgroundColor,
              "popupButtonBackgroundColor"
            );

          this.vmodel.friendminimized.popupButtonTextColor = this.rgbaToHex(
            this.vmodel.friendminimized.popupButtonTextColor,
            "popupButtonTextColor"
          );

          this.vmodel.friendminimized.widgetBackgroundColor = this.rgbaToHex(
            this.vmodel.friendminimized.widgetBackgroundColor,
            "widgetBackgroundColor"
          );

          this.vmodel.friendminimized.textColor = this.rgbaToHex(
            this.vmodel.friendminimized.textColor,
            "textColor"
          );

          this.vmodel.friendmaximized.minwidPopupButtonBackgroundColor =
            this.rgbaToHex(
              this.vmodel.friendmaximized.minwidPopupButtonBackgroundColor,
              "minwidPopupButtonBackgroundColor"
            );

          this.vmodel.friendmaximized.minwidPopupButtonTextColor =
            this.rgbaToHex(
              this.vmodel.friendmaximized.minwidPopupButtonTextColor,
              "minwidPopupButtonTextColor"
            );

          this.vmodel.friendmaximized.widgetShadowColor = this.rgbaToHex(
            this.vmodel.friendmaximized.widgetShadowColor,
            "widgetShadowColor"
          );

          this.vmodel.friendmaximized.popupButtonBackgroundColor =
            this.rgbaToHex(
              this.vmodel.friendmaximized.popupButtonBackgroundColor,
              "popupButtonBackgroundColor"
            );

          this.vmodel.friendmaximized.popupButtonTextColor = this.rgbaToHex(
            this.vmodel.friendmaximized.popupButtonTextColor,
            "popupButtonTextColor"
          );

          this.vmodel.friendmaximized.widgetBackgroundColor = this.rgbaToHex(
            this.vmodel.friendmaximized.widgetBackgroundColor,
            "widgetBackgroundColor"
          );

          this.vmodel.friendmaximized.setTextColor = this.rgbaToHex(
            this.vmodel.friendmaximized.setTextColor,
            "textColor"
          );
          if (this.vmodel.configuration.setSiteId !== null) {
            this.handleSiteIdChange();
          }
        }
      );
    },
    async statusChange() {
      var _url = "/deal/statuschange";
      this.ShowStatusChangePopup = false;
      DataLayerService.getById(_url, this.id).then((result) => {
        this.$toast.add({
          detail: result.message,
          severity: "success",
          life: 3000,
        });
        this.$router.push({ name: "ModifyDeal" });
      });
    },
    onCancel() {
      this.ShowStatusChangePopup = false;
    },
    statusChangePopup(id, status) {
      // var _deal = this.id;
      var _deal1 = this.vmodel.configuration.setName;
      this.statuschange_message =
        "Are you sure to " + status + " '" + _deal1 + "' deal ?";
      this.statusid = id;
      this.status = status;
      this.ShowStatusChangePopup = true;
    },
    getStatusIconClass() {
      if (this.vmodel.statusText === "Paused") {
        return "pauseicon";
      } else if (this.vmodel.statusText === "Unpublish") {
        return "unpublishicon";
      } else if (this.vmodel.statusText === "Expired") {
        return "expiredicon";
      } else if (this.vmodel.statusText === "Stand By") {
        return "pauseicon";
      } else if (this.vmodel.statusText === "Suspended") {
        return "suspendedicon";
      } else {
        return "liveicon";
      }
    },
    getStatusButtonClass() {
      if (this.vmodel.statusText === "Paused") {
        return "yellow-live-icon";
      } else if (this.vmodel.statusText === "Unpublish") {
        return "unpublish-live-icon";
      } else if (this.vmodel.statusText === "Expired") {
        return "expired-icon";
      } else if (this.vmodel.statusText === "Stand By") {
        return "yellow-live-icon";
      } else if (this.vmodel.statusText === "Suspended") {
        return "suspended-icon";
      } else {
        return "live-icon";
      }
    },
    previewWidget() {
      if (this.selectedPreview === "AW") {
        window.open(
          process.env.VUE_APP_URL +
            "?redeal-mode=preview&redeal-type=ambassadorinstant&campaignid=" +
            this.$route.params.id +
            "&envpreviewurl=" +
            process.env.VUE_APP_PREVIEW_URL
        );
      } else if (this.selectedPreview === "FW") {
        window.open(
          process.env.VUE_APP_URL +
            "?redeal-mode=preview&redeal-type=friend&campaignid=" +
            this.$route.params.id +
            "&envpreviewurl=" +
            process.env.VUE_APP_PREVIEW_URL
        );
      } else if (this.selectedPreview === "ARW") {
        window.open(
          process.env.VUE_APP_URL +
            "?redeal-mode=preview&redeal-type=ambassadorrecall&campaignid=" +
            this.$route.params.id +
            "&envpreviewurl=" +
            process.env.VUE_APP_PREVIEW_URL
        );
      } else if (this.selectedPreview === "FRW") {
        window.open(
          process.env.VUE_APP_URL +
            "?redeal-mode=preview&redeal-type=friendrecall&campaignid=" +
            this.$route.params.id +
            "&envpreviewurl=" +
            process.env.VUE_APP_PREVIEW_URL
        );
      }
    },
    hasValidationError(tab) {
      switch (tab) {
        case "settings":
          return (
            this.v$.vmodel.configuration.$pending ||
            this.v$.vmodel.configuration.$error ||
            this.v$.vmodel.schedulingVal.$pending ||
            this.v$.vmodel.schedulingVal.$error ||
            this.v$.vmodel.rewards.$pending ||
            this.v$.vmodel.rewards.$error
          );
        case "configuration":
          return (
            this.v$.vmodel.configuration.$pending ||
            this.v$.vmodel.configuration.$error
          );
        case "rewards":
          return (
            this.v$.vmodel.rewards.$pending || this.v$.vmodel.rewards.$error
          );
        case "scheduling":
          return (
            this.v$.vmodel.schedulingVal.$pending ||
            this.v$.vmodel.schedulingVal.$error
          );
        case "minimized":
          return (
            this.v$.vmodel.minimized.$pending || this.v$.vmodel.minimized.$error
          );
        case "maximized":
          return (
            this.v$.vmodel.maximized.$pending || this.v$.vmodel.maximized.$error
          );
        case "message":
          return (
            this.v$.vmodel.message.$pending || this.v$.vmodel.message.$error
          );
        case "frdMaximized":
          return (
            this.v$.vmodel.friendmaximized.$error ||
            this.v$.vmodel.friendmaximized.$pending
          );
        default:
          return false;
      }
    },

    hasMaximizedError(data) {
      this.hasMaximizeErr = data;
    },

    hasFrdMaximizedError(data) {
      this.hasFrdMaximizeErr = data;
    },

    stayOnPage(ShowChangesChecks, isOK) {
      if (ShowChangesChecks == true && isOK == true) {
        this.$router.push({ name: "ModifyDeal" });
      }
    },
    async voyadoInsite(setSiteId) {
      await DataLayerService.getById(
        "/site/getSiteConfiguration",
        setSiteId
      ).then(async (result) => {
        await (this.voyadoApi = result.campaignView.settings.voyadoApi);
        await (this.voyadoDomain = result.campaignView.settings.voyadoDomain);
        // if (result.success == false) {
        //   if (this.vmodel.ambassador.codeValue == 2)
        //     this.vmodel.ambassador.codeValue = 0;
        //   if (this.vmodel.friend.codeValue == 2)
        //     this.vmodel.friend.codeValue = 0;
        // }
      });
    },
    async saveData() {
      if (this.vmodel) {
        this.vmodel.postEvent = "update";
      }
      this.v$.vmodel.configuration.$touch();
      this.v$.vmodel.maximized.$touch();
      // this.v$.vmodel.schedulingVal.$touch();
      this.v$.vmodel.rewards.$touch();
      this.v$.vmodel.message.$touch();
      this.v$.vmodel.minimized.$touch();
      this.v$.vmodel.friendconfig.$touch();
      this.v$.vmodel.referrals.$touch();
      if (this.vmodel.configuration.ambNeverDisplay == false) {
        this.v$.vmodel.friendmaximized.$touch();
      }
      if (this.$route.name !== "ManageDealUpdateCreate") {
        this.v$.vmodel.schedulingVal.$touch();
      }

      // await (this.submitter = this.vmodel.postEvent);
      // // await (this.submitter = "publish");
      // if (this.vmodel.configuration.ambNeverDisplay == false) {
      //   this.$refs.maximizeComponent.validateCustomTag();
      //   this.$refs.frdMaximizeComponent.validateCustomTag();
      // }

      if (
        this.v$.vmodel.configuration.$pending ||
        this.v$.vmodel.configuration.$error ||
        this.v$.vmodel.maximized.$error ||
        this.v$.vmodel.maximized.$pending ||
        this.v$.vmodel.schedulingVal.$error ||
        this.v$.vmodel.schedulingVal.$pending ||
        this.v$.vmodel.rewards.$error ||
        this.v$.vmodel.rewards.$pending ||
        this.v$.vmodel.message.$error ||
        this.v$.vmodel.message.$pending ||
        this.v$.vmodel.minimized.$error ||
        this.v$.vmodel.minimized.$pending ||
        this.v$.vmodel.friendmaximized.$error ||
        this.v$.vmodel.friendmaximized.$pending ||
        this.v$.vmodel.friendconfig.$error ||
        this.v$.vmodel.friendconfig.$pending ||
        this.v$.vmodel.referrals.$error ||
        this.v$.vmodel.referrals.$pending
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please correct the validation",
          life: 3000,
        });
        return false;
      }

      if (this.hasMaximizeErr || this.hasFrdMaximizeErr) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please correct the validation",
          life: 3000,
        });
        return false;
      }

      this.vmodel.maximized.popupButtonTextColor = this.hex8ToRgba(
        this.vmodel.maximized.popupButtonTextColor
      );

      this.vmodel.maximized.popupButtonBackgroundColor = this.hex8ToRgba(
        this.vmodel.maximized.popupButtonBackgroundColor
      );

      this.vmodel.maximized.widgetBackgroundColor = this.hex8ToRgba(
        this.vmodel.maximized.widgetBackgroundColor
      );

      this.vmodel.maximized.setTextColor = this.hex8ToRgba(
        this.vmodel.maximized.setTextColor
      );

      this.vmodel.minimized.minwidPopupButtonTextColor = this.hex8ToRgba(
        this.vmodel.minimized.minwidPopupButtonTextColor
      );

      this.vmodel.minimized.minwidPopupButtonBackgroundColor = this.hex8ToRgba(
        this.vmodel.minimized.minwidPopupButtonBackgroundColor
      );

      this.vmodel.minimized.setWidgetShadowColor = this.hex8ToRgba(
        this.vmodel.minimized.setWidgetShadowColor
      );

      this.vmodel.friendminimized.minwidPopupButtonBackgroundColor =
        this.hex8ToRgba(
          this.vmodel.friendminimized.minwidPopupButtonBackgroundColor
        );

      this.vmodel.friendminimized.minwidPopupButtonTextColor = this.hex8ToRgba(
        this.vmodel.friendminimized.minwidPopupButtonTextColor
      );

      this.vmodel.friendminimized.widgetShadowColor = this.hex8ToRgba(
        this.vmodel.friendminimized.widgetShadowColor
      );

      this.vmodel.friendminimized.popupButtonBackgroundColor = this.hex8ToRgba(
        this.vmodel.friendminimized.popupButtonBackgroundColor
      );

      this.vmodel.friendminimized.popupButtonTextColor = this.hex8ToRgba(
        this.vmodel.friendminimized.popupButtonTextColor
      );

      this.vmodel.friendminimized.widgetBackgroundColor = this.hex8ToRgba(
        this.vmodel.friendminimized.widgetBackgroundColor
      );

      this.vmodel.friendminimized.textColor = this.hex8ToRgba(
        this.vmodel.friendminimized.textColor
      );

      this.vmodel.friendmaximized.minwidPopupButtonBackgroundColor =
        this.hex8ToRgba(
          this.vmodel.friendmaximized.minwidPopupButtonBackgroundColor
        );

      this.vmodel.friendmaximized.minwidPopupButtonTextColor = this.hex8ToRgba(
        this.vmodel.friendmaximized.minwidPopupButtonTextColor
      );

      this.vmodel.friendmaximized.widgetShadowColor = this.hex8ToRgba(
        this.vmodel.friendmaximized.widgetShadowColor
      );

      this.vmodel.friendmaximized.popupButtonBackgroundColor = this.hex8ToRgba(
        this.vmodel.friendmaximized.popupButtonBackgroundColor
      );

      this.vmodel.friendmaximized.popupButtonTextColor = this.hex8ToRgba(
        this.vmodel.friendmaximized.popupButtonTextColor
      );

      this.vmodel.friendmaximized.widgetBackgroundColor = this.hex8ToRgba(
        this.vmodel.friendmaximized.widgetBackgroundColor
      );

      this.vmodel.friendmaximized.setTextColor = this.hex8ToRgba(
        this.vmodel.friendmaximized.setTextColor
      );
      if (
        this.$route.name == "ManageDealUpdateCreate" &&
        (this.id == null || this.id == undefined)
      ) {
        this.displayPublish = true;
      } else {
        this.formSubmit("update");
      }
    },
    generateNowClick(name) {
      this.vmodel.scheduling.pubStartDate = new Date();
      this.vmodel.postEvent = name;
      this.formSubmit(name);
    },
    generateNot(name) {
      this.vmodel.postEvent = name;
      this.formSubmit(name);
    },
    async generateLater(name) {
      await this.v$.vmodel.publishStartDate.$touch();
      if (
        this.v$.vmodel.publishStartDate.$error ||
        this.v$.vmodel.publishStartDate.$pending
      ) {
        return false;
      }
      this.vmodel.scheduling.pubStartDate = this.startDate;
      this.vmodel.postEvent = name;
      this.formSubmit(name);
    },
    async formSubmit(dealstatus) {
      if (this.vmodel) {
        this.vmodel.postEvent = dealstatus;
      }

      this.vmodel1 = ManageDealUpdateNewPayload.createFromJsonArray(
        this.vmodel
      );


      await DataLayerService.post(
        "/OnSite/ManageDealUpdate",
        this.vmodel1
      ).then((result) => {
        if (result.success == true) {
          this.$router.push({ name: "ModifyDeal" });
        } else {
          this.$router.go();
        }
        if (result.success == true) {
          this.$toast.add({
            detail: result.message,
            severity: "success",
            life: 3000,
          });
          this.displaySelectDate = false;
        } else {
          this.$toast.add({
            detail: result.message,
            severity: "error",
            life: 3000,
          });
        }
      });
    },
    handleEditClick() {
      this.isDisabled = true;
    },
    handleCancelClick() {
      this.isCancelClick = false;
    },
    findAndReplace() {
      this.showPopup = true;
    },
    // closePopup() {
    //   this.showPopup = false;
    // },

    //find_replace
    FindReplace() {
      this.displayReplace = true;
      this.ShowFindPopup = false;
    },
    onReplaceCancel() {
      this.displayReplace = false;
      this.ShowFindPopup = true;
      this.inputTextValue = "";
      this.searchCount = "";
      this.searchResults = [];
    },
    cancel() {
      this.ShowFindPopup = false;
      this.inputTextValue = "";
      this.searchCount = 0;
      // this.searchResults = [];
      // this.isSearchPerformed = false;
    },
    closePopup() {
      this.ShowFindPopup = false;
      this.inputTextValue = "";
      this.searchCount = "";
      this.searchResults = [];
      // this.isSearchPerformed = false;
    },
    closeWarnPopup() {
      this.displayReplace = false;
      this.ShowFindPopup = true;
    },
    handleClose() {
      this.ShowFindPopup = false;
      this.inputTextValue = "";
      this.searchCount = "";
    },

    handleSearch() {
      var model = {
        pDealId: this.id,
        pTargetword: this.inputTextValue,
        pReplaceword: this.replaceTextValue,
      };
      DataLayerService.post("/deal/ReplaceText", model).then((result) => {
        this.count = result.item1;
        this.replaceTextLbl = result.item3;
        this.searchCount = "Number of occurrence : " + this.count;
        // this.searchResults = result.item2 ? result.item2 : [];
        // this.isSearchPerformed = this.count > 0;

        if (result.item1 == -1) {
          this.$toast.add({
            detail: result.item3,
            severity: "error",
            life: 3000,
          });
        }
      });
    },
    handleReplace() {
      var model = {
        pDealId: this.id,
        pTargetword: this.inputTextValue,
        pReplaceword: this.replaceTextValue,
      };
      if (
        this.replaceTextValue !== null ||
        this.replaceTextValue !== undefined ||
        this.replaceTextValue !== ""
      ) {
        DataLayerService.post("/deal/ReplaceText", model).then((result) => {
          if (result.item2 == true) {
            this.$toast.add({
              detail: "Successfully replace.",
              severity: "success",
              life: 3000,
            });
            window.location.reload();
          } else {
            this.$toast.add({
              detail: "Error",
              severity: "error",
              life: 3000,
            });
          }
          this.displayReplace = false;
          this.ShowFindPopup = false;
          this.inputTextValue = "";
        });
      }
    },

    //New method
    toggleEditMode(tab) {
      this.isEditMode = true;
      this.isDisabled = false;
      this.isCancelClick = true;
      this.isConfig = tab === "config";
      this.isRwd = tab === "rewards";
      this.isTarget = tab === "target";
      this.isSchedule = tab === "scheduling";
      this.isFriendConfig = tab === "friendconfig";
      this.isReferrals = tab === "referrals";
    },
    handleSaved() {},
    deviceType(value) {
      this.selectedDeviceType = value;
      if (value === "mobile") {
        this.desktopSelect = false;
        this.mobileSelect = true;
      } else if (value === "desktop") {
        this.desktopSelect = true;
        this.mobileSelect = false;
      }
    },
    activateTab(tabName) {
      this.settingTab = tabName === "setting";
      this.minimizedTab = tabName === "minimized";
      this.maximizedTab = tabName === "maximized";
      this.frdmaximizedTab = tabName === "frdmaximized";
      this.messageTab = tabName === "message";
      this.returnTab = tabName === "returnvisit";
      this.friendmessageTab = tabName === "friendmessage";
      this.friendreturnvisitTab = tabName === "friendreturnvisit";
      this.friendminimizedTab = tabName === "friendminimized";
    },
    checkTriggerSelected(triggerKeys) {
      let hasSelected = false;
      const pathKeyValueTriggers = triggerKeys;
      if (
        this.vmodel.ambassador.dealTriggers &&
        this.vmodel.ambassador.dealTriggers.length > 0
      ) {
        this.vmodel.ambassador.dealTriggers.forEach((element) => {
          if (pathKeyValueTriggers.indexOf(element) > -1) {
            hasSelected = true;
          }
        });
      }
      return hasSelected;
    },
    hex8ToRgba(hex8) {
      if (!hex8) {
        return;
      }

      hex8 = hex8.startsWith("#") ? hex8 : "#" + hex8;

      const bigint = parseInt(hex8.slice(1), 16);
      const red = (bigint >> 24) & 255;
      const green = (bigint >> 16) & 255;
      const blue = (bigint >> 8) & 255;
      const alpha = (bigint & 255) / 255;

      return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
    },
    rgbaToHex(rgba, name) {
      if (!rgba || typeof rgba !== "string") {
        return null;
      }

      const rgbaMatch = rgba.match(
        /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d+(\.\d+)?)\)$/
      );
      // Where in database store color not in rgba formate.
      if (!rgbaMatch) {
        let defaultRgba;
        // if (name == "minwidPopupButtonBackgroundColor") {
        //   defaultRgba = "rgba(0, 0, 0, 1)"; // Black color with full opacity
        // } else if (name == "minwidPopupButtonTextColor") {
        //   defaultRgba = "rgba(255, 255, 255, 1)";
        // } else if (name == "popupButtonBackgroundColor") {
        //   defaultRgba = "rgba(0, 0, 0, 1)";
        // } else if (name == "popupButtonTextColor") {
        //   defaultRgba = "rgba(255, 255, 255, 1)";
        // } else if (name == "widgetBackgroundColor") {
        //   defaultRgba = "rgba(255, 255, 255, 1)";
        // } else if (name == "widgetShadowColor") {
        //   defaultRgba = "rgba(128, 128, 128, 1)";
        // }
        return this.rgbaToHex(defaultRgba, name);
      }

      const [, r, g, b, a] = rgbaMatch.map(Number);

      const red = Math.min(255, Math.max(0, r));
      const green = Math.min(255, Math.max(0, g));
      const blue = Math.min(255, Math.max(0, b));
      const alpha = Math.min(1, Math.max(0, a));

      const hex = `#${Math.round(red)
        .toString(16)
        .padStart(2, "0")}${Math.round(green)
        .toString(16)
        .padStart(2, "0")}${Math.round(blue)
        .toString(16)
        .padStart(2, "0")}${Math.round(alpha * 255)
        .toString(16)
        .padStart(2, "0")}`;

      return hex.toUpperCase();
    },

    openGetMeCodePopup(isCustomer) {
      DataLayerService.getById("/deal/getmecode", this.id, isCustomer).then(
        (result) => {
          if (
            result.success == true &&
            result.data != null &&
            result.data != undefined
          ) {
            this.code = result.data;
            this.ShowGetMeCodePopup = true;
          } else {
            this.$toast.add({
              detail: result.message,
              severity: "success",
              life: 3000,
            });
          }
        }
      );
    },

    exportUnusedCode(isCustomer, type) {
      DataLayerService.getById(
        "/deal/exportUnusedCode",
        this.id,
        isCustomer
      ).then((result) => {
        const anchor = document.createElement("a");
        const encodedURI = encodeURI(result);
        const fixedEncodedURI = encodedURI.replaceAll("#", "%23");

        anchor.href = "data:text/csv;charset=utf-8,%EF%BB%BF" + fixedEncodedURI;
        anchor.target = "_blank";
        anchor.download =
          this.vmodel.name.replace(" ", "_") + type + "unused" + ".csv";
        anchor.click();
      });
    },

    getDateParsed(dateforparse) {
      if (dateforparse) {
        dateforparse =
          dateforparse.indexOf("T") > 0
            ? dateforparse.split("T")
            : dateforparse.split(" ");
        let dateArray = dateforparse[0].split("-");
        let timeArray = dateforparse[1].split(":");
        let newDate = new Date(
          dateArray[0],
          parseInt(dateArray[1] - 1),
          dateArray[2],
          timeArray[0],
          timeArray[1]
        );
        return newDate;
      }
    },

    async getStaticData() {
      await DataLayerService.getById("/OnSite/GetStaticData", this.id).then(
        (result) => {
          this.lmodel = result.labelModel;
          this.dmodel = result.dropdownListModel;
        }
      );
    },

    async getDataById() {
      var clientTimezoneOffset = new Date().getTimezoneOffset();

      var pageURL = "/OnSite/GetDealById";
      // if (this.pageName == "copydealnew") {
      //   pageURL += "copydeal";
      // } else {
      //   pageURL += "GetDealById";
      // }
      try {
        const result = await DataLayerService.getById(
          pageURL,
          this.id,
          clientTimezoneOffset
        );

        if (!result.viewModel) {
          console.error("ViewModel not found in result:", result);
          return;
        }
        if (!result.viewModel.ambDealTriggers) {
          result.viewModel.ambDealTriggers = [];
        }
        const modelData = result.viewModel;
        modelData.pubStartDate = this.getDateParsed(
          result.viewModel.pubStartDate
        );
        modelData.pubPauseDate = this.getDateParsed(
          result.viewModel.pubPauseDate
        );
        modelData.pubRePublishDate = this.getDateParsed(
          result.viewModel.pubRePublishDate
        );
        modelData.pubEndDate = this.getDateParsed(result.viewModel.pubEndDate);
        let date = new Date();
        date.setDate(date.getDate() + 1);
        modelData.ambcustomerCodeExpirationDate =
          modelData.ambcustomerCodeExpirationDate || date;
        if (
          result.viewModel == null ||
          result.viewModel.id == null ||
          result.viewModel.setCompanyId == null
        ) {
          this.$router.push({ name: "ModifyDeal" });
        }
        this.$store.commit("replaceCompanyId", modelData.setCompanyId);
        this.vmodel =
          ManageResponseUpdateFactory.createFromJsonArray(modelData);

        this.vmodel.maximized.popupButtonTextColor = this.rgbaToHex(
          this.vmodel.maximized.popupButtonTextColor,
          "popupButtonTextColor"
        );

        this.vmodel.maximized.popupButtonBackgroundColor = this.rgbaToHex(
          this.vmodel.maximized.popupButtonBackgroundColor,
          "popupButtonBackgroundColor"
        );

        this.vmodel.maximized.widgetBackgroundColor = this.rgbaToHex(
          this.vmodel.maximized.widgetBackgroundColor,
          "widgetBackgroundColor"
        );

        this.vmodel.maximized.setTextColor = this.rgbaToHex(
          this.vmodel.maximized.setTextColor,
          "setTextColor"
        );

        this.vmodel.minimized.minwidPopupButtonTextColor = this.rgbaToHex(
          this.vmodel.minimized.minwidPopupButtonTextColor,
          "minwidPopupButtonTextColor"
        );

        this.vmodel.minimized.minwidPopupButtonBackgroundColor = this.rgbaToHex(
          this.vmodel.minimized.minwidPopupButtonBackgroundColor,
          "minwidPopupButtonBackgroundColor"
        );

        this.vmodel.minimized.setWidgetShadowColor = this.rgbaToHex(
          this.vmodel.minimized.setWidgetShadowColor,
          "setWidgetShadowColor"
        );

        this.vmodel.friendminimized.minwidPopupButtonBackgroundColor =
          this.rgbaToHex(
            this.vmodel.friendminimized.minwidPopupButtonBackgroundColor,
            "minwidPopupButtonBackgroundColor"
          );

        this.vmodel.friendminimized.minwidPopupButtonTextColor = this.rgbaToHex(
          this.vmodel.friendminimized.minwidPopupButtonTextColor,
          "minwidPopupButtonTextColor"
        );

        this.vmodel.friendminimized.widgetShadowColor = this.rgbaToHex(
          this.vmodel.friendminimized.widgetShadowColor,
          "widgetShadowColor"
        );

        this.vmodel.friendminimized.popupButtonBackgroundColor = this.rgbaToHex(
          this.vmodel.friendminimized.popupButtonBackgroundColor,
          "popupButtonBackgroundColor"
        );

        this.vmodel.friendminimized.popupButtonTextColor = this.rgbaToHex(
          this.vmodel.friendminimized.popupButtonTextColor,
          "popupButtonTextColor"
        );

        this.vmodel.friendminimized.widgetBackgroundColor = this.rgbaToHex(
          this.vmodel.friendminimized.widgetBackgroundColor,
          "widgetBackgroundColor"
        );

        this.vmodel.friendminimized.textColor = this.rgbaToHex(
          this.vmodel.friendminimized.textColor,
          "textColor"
        );

        this.vmodel.friendmaximized.minwidPopupButtonBackgroundColor =
          this.rgbaToHex(
            this.vmodel.friendmaximized.minwidPopupButtonBackgroundColor,
            "minwidPopupButtonBackgroundColor"
          );

        this.vmodel.friendmaximized.minwidPopupButtonTextColor = this.rgbaToHex(
          this.vmodel.friendmaximized.minwidPopupButtonTextColor,
          "minwidPopupButtonTextColor"
        );

        this.vmodel.friendmaximized.widgetShadowColor = this.rgbaToHex(
          this.vmodel.friendmaximized.widgetShadowColor,
          "widgetShadowColor"
        );

        this.vmodel.friendmaximized.popupButtonBackgroundColor = this.rgbaToHex(
          this.vmodel.friendmaximized.popupButtonBackgroundColor,
          "popupButtonBackgroundColor"
        );

        this.vmodel.friendmaximized.popupButtonTextColor = this.rgbaToHex(
          this.vmodel.friendmaximized.popupButtonTextColor,
          "popupButtonTextColor"
        );

        this.vmodel.friendmaximized.widgetBackgroundColor = this.rgbaToHex(
          this.vmodel.friendmaximized.widgetBackgroundColor,
          "widgetBackgroundColor"
        );

        this.vmodel.friendmaximized.setTextColor = this.rgbaToHex(
          this.vmodel.friendmaximized.setTextColor,
          "textColor"
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  -webkit-box-align: center;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  left: 0px;
  right: 0px;
  z-index: 12;
  height: 80px;
  padding: 0px 15px;
}

.white-bg {
  background: #fff;
  border-bottom: 1px solid #f1f2f7;
}

.vertical-line {
  display: flex;
  border: 1px solid #f2f2f2;
  height: 100px;
  width: 0px;
}
.vertical-line-disable {
  height: 62px;
  width: 0px;
}

.fa {
  height: 30px;
}

.wizard-menu {
  display: flex;
  flex-direction: row;
  gap: 10px;
  top: 72px;
  height: 76px !important;
  width: 100%;
  background: white;
  position: fixed;
  overflow-x: auto;
  overflow-y: hidden;
  outline: none;
  padding-left: 4px;
  z-index: 12;
  border-bottom: 2px solid #f2f2f2;
}

.p-dropdown-panel {
  z-index: 1005 !important;
  position: absolute !important;
  top: auto !important;
  bottom: calc(100% + 10px) !important;
  left: 0 !important;
}

.p-dropdown {
  overflow: visible !important;
  background: none !important ;
}
.wizard-menu-selected {
  border: 2px solid #4e83ae !important;
}
.wizard-text-selected {
  background: #e5edf3 !important;
}
.wizard-image {
  height: 30px;
  width: 40px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.wizard-text {
  //  padding: 3px;
  font-weight: 900;
  font-size: 12px;
  line-height: 17.07px;
  font-family: "Voyado Text";
}

.wizard-text-color {
  //  padding: 3px;
  font-weight: 900;
  font-size: 12px;
  line-height: 17.07px;
  color: #79193f;
  font-family: "Voyado Text";
}

.widget-menudropdown,
.widget-menudropdown:hover {
  border: 2px solid #e0e9e8 !important;
  width: auto;
  height: 40px;
  border-radius: 4px;
  line-height: 15px;
  color: #2d6e6d;
  position: relative;
  align-items: center !important;
  z-index: 1004 !important;
}

::v-deep(.p-breadcrumb) {
  background: transparent;
  padding: 0;
}
::v-deep(.p-breadcrumb .p-breadcrumb-list li.p-menuitem-separator) {
  color: #5a5a5a;
}
::v-deep(.p-breadcrumb .p-breadcrumb-list li.p-menuitem-separator .pi) {
  font-size: 12px;
}
::v-deep(
    .p-breadcrumb .p-breadcrumb-list li .p-menuitem-link .p-menuitem-text
  ) {
  font-size: 12px;
  color: #5a5a5a;
  font-weight: 900;
  font-family: "Voyado Text";
}
.headervalue {
  padding: 8px, 0px, 0px, 0px;
}
.icon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.save-btn1 {
  background-color: #2d6e6d;
  border-radius: 4px;
  height: 40px;
  width: auto;
  padding: 0px 16px 0px 16px;
  border-color: #2d6e6d;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  line-height: 1.5;
  box-shadow: none !important;
  top: 0px;
  font-family: "Voyado Text" !important;
}
.save-btn1:hover {
  border-color: #2d6e6d !important;
  background-color: #2d6e6d !important;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
}
.arrow-container {
  margin-top: 25px;
  font-weight: 400;
  line-height: 12.8px;
}

.wrapperAdd {
  margin: 0 auto;
  width: 100%;
}
.wrapperAdd.mid-width {
  max-width: 920px;
}

.card-1 {
  margin-top: 5px;
  padding: 0px;
}

:deep(.card-mid) {
  border-color: #eff2f7;
  background: #fff;
  font-size: 1rem;
  font-weight: 400;
  padding: 0rem 0rem !important;
  margin-bottom: 0;
}
.border-box {
  border: 1px solid #c0c0bc;
  border-radius: 4px;
}
.mobile {
  background-color: white !important;
  color: black !important;
  border: none !important;
  padding: 6px 12px 6px 12px !important;
  margin-right: 2px;
  width: 36px !important;
  // height: 40px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.desktop {
  background-color: white !important;
  color: black !important;
  border: none !important;
  padding: 6px 12px 6px 12px !important;
  margin-left: 2px;
  width: 36px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
:deep(.mobile:hover) {
  background-color: #79193f !important;
  color: #fff !important;
  border: 1px solid #79193f !important;
  padding: 6px 12px 6px 12px !important;
  width: 36px !important;
  position: relative;
  box-shadow: none !important;
}
:deep(.desktop:hover) {
  background-color: #79193f !important;
  color: #fff !important;
  border: 1px solid #79193f !important;
  padding: 6px 12px 6px 12px !important;
  width: 36px !important;
  position: relative;
  // background: transparent;
  box-shadow: none !important;
}
.active-btn {
  color: #fff !important;
  background-color: #79193f !important;
  border: 1px solid #79193f !important;
  color: #fff !important;
  width: 36px !important;
  background: transparent;
  padding: 6px 12px 6px 12px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.border-box-button {
  border-radius: 4px !important;
  border: 1px solid #c0c0bc !important;
  padding: 3px 4px 3px 4px !important;
  width: auto !important;
  height: 42px !important;
  display: flex !important;
  // line-height: 11px;
}
.selected-tab-settings {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  top: 25px;
  width: 100%;
  background-color: #79193f;
}
.selected-tab {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  top: 28px;
  width: 100%;
  background-color: #79193f;
}
:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
}
:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
  // border: solid #e2e8f0;
  border-width: 0 0 1px 0;
  border-color: transparent transparent #e2e8f0 transparent;
  background: #ffffff;
  color: #000000;
  // padding: 1rem 1.125rem;
  font-weight: 400;
  font-size: 14.22px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s, outline-color 0.2s;
  margin: 0 0 -1px 0;
  outline-color: transparent;
}

:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link) {
  background: #ffffff;
  border-color: white;
  color: #000000;
  font-weight: 400;
  font-size: 14.22px;
  line-height: 17.1px;
}
// :deep(
//     .p-tabview.wizard-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link
//   ) {
//   border-bottom: 4px solid #791a3f !important;
// }

:deep(.p-tabview .p-tabview-nav li.p-disabled .p-tabview-nav-link) {
  padding: 0rem 1rem !important;
  border: none !important;
}

:deep(.p-tabview .p-tabview-ink-bar) {
  z-index: 1;
  display: block;
  position: absolute;
  bottom: 0px;
  height: 3px;
  background-color: #791a3f;
}

:deep(.setting-layout.p-tabview .p-tabview-panels) {
  overflow-y: auto;
  overflow-x: hidden;
  height: -webkit-fill-available !important;
}
:deep(.p-tabview .p-tabview-panels) {
  padding: 16px !important;
  background: #ffffff;
  border: 0 none;
  color: #212529;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.wizard-tabview {
  display: flex;
  width: 100%;
  justify-content: center;
}
//Additional
.verti-line {
  display: flex;
  border: 1px solid #f2f2f2;
  // border: 1px solid red;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 2px;
  height: 37px;
  width: 0px;
}
.verti-line-disable {
  height: 37px;
  width: 0px;
}
.live-icon {
  background-color: #43a584;
  border-radius: 20px;
  border-color: #43a584 !important;
  width: 32px !important;
  height: 32px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  margin-top: 4px !important;
}
.live-icon:hover {
  background-color: #43a584 !important;
  border-radius: 20px;
  border-color: #43a584 !important;
  width: 32px !important;
  height: 32px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.expired-icon {
  background-color: #ff6c60;
  border-radius: 20px;
  border-color: #ff6c60 !important;
  width: 32px !important;
  height: 32px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  margin-top: 4px !important;
}
.expired-icon:hover {
  background-color: #ff6c60 !important;
  border-radius: 20px;
  border-color: #ff6c60 !important;
  width: 32px !important;
  height: 32px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.suspended-icon {
  background-color: #e31200 !important;
  border-radius: 20px;
  border-color: #e31200 !important;
  width: 32px !important;
  height: 32px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  margin-top: 4px !important;
}
.suspended-icon:hover {
  background-color: #e31200 !important;
  border-radius: 20px;
  border-color: #e31200 !important;
  width: 32px !important;
  height: 32px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.yellow-live-icon {
  background-color: #e4ba00;
  border-radius: 20px;
  border-color: #e4ba00 !important;
  width: 32px !important;
  height: 32px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  margin-top: 4px !important;
}
.yellow-live-icon:hover {
  background-color: #e4ba00 !important;
  border-radius: 20px;
  border-color: #e4ba00 !important;
  width: 32px !important;
  height: 32px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.unpublish-live-icon {
  background-color: #a1a1a1;
  border-radius: 20px;
  border-color: #a1a1a1 !important;
  width: 32px !important;
  height: 32px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  margin-top: 4px !important;
}
.unpublish-live-icon:hover {
  background-color: #a1a1a1 !important;
  border-radius: 20px;
  border-color: #a1a1a1 !important;
  width: 32px !important;
  height: 32px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.live-text {
  font-family: "Voyado text";
  font-weight: 500;
  color: #21211f;
  align-content: center;
  margin-left: 8px;
  line-height: 17.07px;
}
.error-state-set {
  color: #e31200 !important;
}
.pause-btn {
  background-color: #fff;
  border-radius: 4px;
  height: 40px;
  width: auto;
  border: 2px solid #e0e9e8;
  padding: 0px 16px 0px 16px;
  align-items: center;
  color: #2d6e6d;
  font-weight: 500;
  font-family: "Voyado Text" !important;
  line-height: 1.5;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.pause-btn:hover {
  border-color: #2d6e6d !important;
  background-color: #fff !important;
  color: #2d6e6d !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.profile-text {
  font-family: "Voyado Display" !important;
  font-size: 25.62891px !important;
  font-weight: 500 !important;
  color: #222222;
}

:deep(.p-breadcrumb .p-breadcrumb-list li .p-menuitem-link .p-menuitem-text) {
  font-family: "Voyado Text";
  font-size: 14.22px;
  font-weight: 700;
  line-height: 17.07px;
  text-align: left;
  color: #797971;
}

.tab-view {
  height: 76px;
}

@media only screen and (max-width: 992px) {
  .wizard-menu {
    height: auto !important;
    min-height: 76px !important;
  }
  .wizard-tabview {
    width: auto;
  }
  :deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
    border: none !important;
    text-align: center;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1362px) {
  .wizard-menu {
    height: auto !important;
    min-height: 76px !important;
  }
  .wizard-tabview {
    width: auto;
  }
  :deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
    border: none !important;
    text-align: center;
  }
}
.header-text {
  display: flex;
  align-items: center;
  height: auto;
  padding: 26px 40px 26px 40px;
  border-radius: 4px 4px 0px 0px;
}
.header-text h5 {
  margin: 0;
}
.header-text span {
  display: block;
  margin-top: 5px;
}
:deep(.heading-text) {
  height: 19px;
  font-family: "Voyado Text";
  font-size: 16px;
  font-weight: 600;
  line-height: 19.2px;
  text-align: left;
  color: #21211f;
}
.header-edit-mode {
  background-color: #f8f8f7 !important;
}
.head-mode {
  background-color: #fff !important;
}
.p-splitbutton.p-button-text > .p-button:enabled:hover {
  color: #e8e8e8;
  background-color: #e8e8e8;
  // -webkit-font-smoothing: 0px;
}
:deep(.icon) {
  .pi-chevron-down:before {
    // content: url("../../assets/images/menu.png");
    content: url("../../assets/icons/option-icon.svg");
    //  color: #2d6e6d !important;
  }
}
.item {
  align-items: flex-start !important;
}

:deep(.p-dropdown-panel .p-component .p-ripple-disabled) {
  z-index: 1004 !important;
  min-width: 179px !important;
  transform-origin: center top !important;
  top: 50.625px !important;
  left: 919.6px !important;
}

.btn-cancel {
  border-color: none !important;
  background: none;
  color: black;
  border: none;
}
.btn-cancel:hover {
  background: none !important;
  color: black !important;
  box-shadow: none !important;
}
.btn-cancel:focus {
  background-color: none !important;
  box-shadow: none !important;
}
.btn-sure {
  border-color: #ff6c60 !important;
  color: #ff6c60;
  background-color: #fff;
}
.btn-sure:hover {
  background-color: #ec6459 !important;
  border-color: #ec6459 !important;
  color: #fff !important;
  box-shadow: none !important;
}
.error-state {
  color: #dc3545 !important;
}

//find-replace popup
.header-container {
  display: flex;
  height: 80px;
  padding: 21px 14px 21px 0px !important;
  align-items: center !important;
}

.header-container .pi {
  margin-left: auto;
  cursor: pointer;
}

.text-header {
  font-family: "Voyado Text" !important;
  font-size: 25.63px !important;
  font-weight: 600 !important;
  line-height: 30.76px !important;
  text-align: center !important;
}

.control-label {
  font-size: 1rem;
  padding-bottom: 3px;
  display: block !important;
  margin-bottom: 0px;
  padding-top: 7px;
  font-weight: normal;
  position: relative;
  vertical-align: top;
}

.search-btn {
  border: 2px solid #e0e9e8;
  background-color: #fff;
  border-radius: 4px;
  color: #2d6e6d;
  font-size: 14.22px;
  line-height: 12.8px;
  font-family: "Voyado Text";
  font-weight: 500;
  height: 40px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.search-btn:hover {
  background-color: white !important;
  border-color: #2d6e6d !important;
  // color: #fff;
  color: #2d6e6d !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline: none !important;
}

::v-deep(.p-dialog .p-dialog-content) {
  padding: 0 !important;
}

.remove-btn {
  border: none;
  color: #2d6e6d;
  height: 40px;
  font-weight: 500;
  font-family: "Voyado text";
  line-height: 12.8px;
  background: #fff;
  padding: 0px 16px 0px 16px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.remove-btn:hover {
  border: none !important;
  color: #2d6e6d !important;
  height: 40px;
  font-weight: 500;
  font-family: "Voyado text";
  line-height: 12.8px;
  background: #fff !important;
  padding: 0px 16px 0px 16px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

// .search-btn:disabled,
// .save-btn1:disabled {
//   background-color: #efefef !important;
//   color: rgb(176, 158, 158) !important;
//   cursor: not-allowed !important;
//   border-color: #efefef !important;
//   -webkit-box-shadow: none !important;
//   box-shadow: none !important;
// }
// .i.replace-icon:disabled {
//   background-color: #efefef !important;
//   color: rgb(50, 48, 48) !important;
// }

:deep(.p-calendar .p-button) {
  color: #000;
  background: #fff;
  border-top: 1px solid #c0c0bc;
  border-right: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  border-left: transparent !important;
  padding: 0 !important;
  -webkit-box-shadow: none;
  box-shadow: none;
}
:deep(.p-calendar .p-button:hover) {
  color: #000;
  background: #fff;
  border-top: 1px solid #c0c0bc;
  border-right: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  border-left: transparent !important;
  padding: 0 !important;
}
:deep(.p-calendar-w-btn .p-inputtext) {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right: none !important;
}

//old dialog box
.input-container1,
.button-container1 {
  flex: 1;
  margin-right: 10px;
}

.input-container2 .mt-2 {
  width: 98%;
  box-sizing: border-box;
}

.dialog-content1 {
  display: flex;
  justify-content: space-between;
}
.footer-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
